<template>
    <div style="background:#FAFAFA;" class="policeLato">

        <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
        <section v-if="isDesktop()">
            <div class="mt-5 pt-5 paralax-cover-image has-background-dim">
                <p class="paralax-cover-image-text">
                <div class="content_home" style="z-index: 1!important;">
                    <h1 style="font-size: 70px" class="font-weight-bold"><span style="color: #fff">{{$t('devis.devis_habitation.header_title[0]') }}</span></h1>
                    <h1 style="font-size: 70px;margin-top: -30px" class="font-weight-bold"><span style="color: #ffa409" class="ml-1">{{ $t('devis.devis_habitation.header_title[1]') }}</span></h1>
                </div>
                </p>
            </div>
        </section>

        <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
        <section class="mt-5" v-if="isMobile()">
            <div class="paralax-cover-image_mobile has-background-dim_mobile">
                <p class="paralax-cover-image-text_mobile">
                <div class="content_home" style="z-index: 1!important;margin-top: 10%">
                    <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">{{
                        $t('devis.devis_habitation.header_title[0]') }}</span></h1>
                    <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>{{
                        $t('devis.devis_habitation.header_title[1]') }}</span></h1>
                </div>
                </p>
            </div>
        </section>
        <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
        <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
        <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
        <!-- ========================================================================================= -->
        <div>
            <div class="container" style="background:#FAFAFA">
                <div class="container justify-content-center row text-center mb-5 mt-5">
                    <p class="mb-3"
                        style="font-weight: 300;color: #ffa409;font-family: Open Sans, sans-serif;font-size:25px!important;">
                        {{ $t('devis.devis_habitation.title[0]') }} <span class="font-weight-bold">{{
                            $t('devis.devis_habitation.title[1]') }}</span> {{ $t('devis.devis_habitation.title[2]') }}
                        <span class="font-weight-bold">{{ $t('devis.devis_habitation.title[3]') }}</span></p> <br>
                </div>
                <br>

                <div class="row" style="background:#FAFAFA" v-if="isDesktop()">
                    <div class="col-md-10 offset-1" style="background:#FAFAFA">
                        <div class="form" style="background:#FAFAFA">
                            <div class="wizard-navigation">
                                <div class="wizard-progress-with-circle">
                                    <div class="wizard-progress-bar"
                                        style="background-color: rgb(231, 76, 60); color: rgb(231, 76, 60); width: 4.54545%;">
                                    </div>
                                </div>
                                <div class="progress-bar-group">
                                    <div class="progress-bar-custom" id="testup"></div>
                                </div>
                                <ul role="tablist" class="wizard-nav wizard-nav-pills">
                                    <li class="step" id="firstStep">
                                        <div class="step-title">{{ $t('devis.devis_habitation.stepper_title[0]') }}</div>
                                    </li>
                                    <li class="step" id="secondStep">
                                        <div class="step-title">{{ $t('devis.devis_habitation.stepper_title[1]') }}</div>
                                    </li>
                                    <li class="step" id="thirstStep">
                                        <div class="step-title">{{ $t('devis.devis_habitation.stepper_title[2]') }}</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" style="background:#FAFAFA" v-if="isMobile()">
                    <div class="col-md-10" style="background:#FAFAFA">
                        <div class="form" style="background:#FAFAFA">
                            <div class="wizard-navigation">
                                <div class="wizard-progress-with-circle">
                                    <div class="wizard-progress-bar"
                                        style="background-color: rgb(231, 76, 60); color: rgb(231, 76, 60); width: 4.54545%;">
                                    </div>
                                </div>
                                <div class="progress-bar-group">
                                    <div class="progress-bar-custom" id="testup"></div>
                                </div>
                                <ul role="tablist" class="wizard-nav wizard-nav-pills">
                                    <li class="step" id="firstStep">
                                        <div class="step-title text-center mr-4">{{
                                            $t('devis.devis_habitation.stepper_title[0]') }}</div>
                                    </li>
                                    <li class="step" id="secondStep">
                                        <div class="step-title text-center mr-4">{{
                                            $t('devis.devis_habitation.stepper_title[1]') }}</div>
                                    </li>
                                    <li class="step" id="thirstStep">
                                        <div class="step-title text-center mr-4">{{
                                            $t('devis.devis_habitation.stepper_title[2]') }}</div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP     =============== -->
                <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
                <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
                <!-- ========================================================================================= -->
                <div v-responsive.lg.xl class="row mt-5" style="background:#FAFAFA">
                    <div class="col-md-10 offset-1" style="background:#FAFAFA">
                        <div class="form" style="background:#FAFAFA">
                            <div class="page mb-5" v-show="step === 0">
                                <div class="wizard-tab-content">
                                    <div role="tabpanel" id="Step1" aria-labelledby="step-Step1"
                                        class="wizard-tab-container">
                                        <div>
                                            <div class="fields">
                                                <div class="field-title font-weight-bold">{{
                                                    $t('devis.devis_habitation.stepper_one_subtitle_one') }}&nbsp;:</div>
                                                <div class="field-group justify-content-center row flex-column flex-sm-row">
                                                    <div class="btn-choice btn-choice-icon sm-no-change">
                                                        <input :disabled="disabledMyHabitation" v-model="myHabitations"
                                                            value="mes_habitations" type="radio" id="Stepper1_1_2"
                                                            name="Step1" class="field-input" @click="getListHabitation">
                                                        <label for="Stepper1_1_2"
                                                            class="flex-row flex-md-column field-label">
                                                            <img src="../assets/img/icones/myhomes.png" class="mr-4 mr-md-0"
                                                                alt="mes logements">
                                                            <p>{{ $t('devis.devis_habitation.my_logement') }}</p>
                                                        </label>
                                                    </div>
                                                    <div class="btn-choice btn-choice-icon sm-no-change ml-4">
                                                        <input v-model="myHabitations" type="radio" value="nouveau"
                                                            id="Stepper2_2_3" name="Step1" class="field-input"
                                                            @change="myHabitationValidator()">
                                                        <label for="Stepper2_2_3"
                                                            class="flex-row flex-md-column field-label">
                                                            <img src="../assets/img/icones/newhome.png" class="mr-4 mr-md-0"
                                                                alt="nouveau logement">
                                                            <p>{{ $t('devis.devis_habitation.new_logement') }}</p>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="page" v-show="step === 1">
                                <div class="wizard-tab-content">
                                    <div role="tabpanel" id="Step1" aria-labelledby="step-Step1"
                                        class="wizard-tab-container">
                                        <div>
                                            <div class="fields">
                                                <div class="field-title font-weight-bold">{{
                                                    $t('devis.devis_habitation.stepper_two_subtitle_two') }}&nbsp;:</div>
                                                <div class="field-group justify-content-center row flex-column flex-sm-row">
                                                    <div class="btn-choice btn-choice-icon sm-no-change">
                                                        <input v-model="naturelogement"
                                                            :value="i18nFrHbitation.natureLogement.labelAppartement_value"
                                                            type="radio" id="Stepper1" name="Step1" class="field-input">
                                                        <label for="Stepper1" class="flex-row flex-md-column field-label">
                                                            <img src="../assets/img/icones/appartments.png"
                                                                class="mr-4 mr-md-0" alt="appartements">
                                                            <p class="text-center">{{
                                                                $t('devis.devis_habitation.natureLogement.labelAppartement_label')
                                                            }}</p>
                                                        </label>
                                                    </div>
                                                    <div class="btn-choice btn-choice-icon sm-no-change ml-4">
                                                        <input v-model="naturelogement" type="radio"
                                                            :value="i18nFrHbitation.natureLogement.labelMaison_value"
                                                            id="Stepper2" name="Step1" class="field-input">
                                                        <label for="Stepper2" class="flex-row flex-md-column field-label">
                                                            <img src="../assets/img/icones/home.png" class="mr-4 mr-md-0"
                                                                alt="home">
                                                            <p class="text-center">{{
                                                                $t('devis.devis_habitation.natureLogement.labelMaison_label')
                                                            }}</p>
                                                        </label>
                                                    </div>
                                                    <div class="btn-choice btn-choice-icon sm-no-change ml-4">
                                                        <input v-model="naturelogement" type="radio"
                                                            :value="i18nFrHbitation.natureLogement.labelImmeuble_value"
                                                            id="Stepper3" name="Step1" class="field-input">
                                                        <label for="Stepper3" class="flex-row flex-md-column field-label">
                                                            <img src="../assets/img/icones/immeuble.png"
                                                                class="mr-4 mr-md-0" alt="immeuble">
                                                            <p class="text-center">{{
                                                                $t('devis.devis_habitation.natureLogement.labelImmeuble_label')
                                                            }}</p>
                                                        </label>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="wizard-tab-content">
                                    <div role="tabpanel" id="Step8" aria-hidden="true" aria-labelledby="step-Step8"
                                        class="wizard-tab-container">
                                        <div>
                                            <div class="loan-group loan-group-0">
                                                <div class="fields">
                                                    <div class="field-title font-weight-bold">{{
                                                        $t('devis.devis_habitation.EtagePiece.superficie_title') }}&nbsp;:
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="Stepper28" class="field-label">{{
                                                                    $t('devis.devis_habitation.EtagePiece.placeholder_nombreetage')
                                                                }}</label>
                                                                <div class="input-group value-loan">
                                                                    <input @keypress="onlyNumber" v-model="nombreetage"
                                                                        :placeholder="$t('devis.devis_habitation.EtagePiece.placeholder_superficie')"
                                                                        id="Stepper28" name="Step8" class="field-input">
                                                                    <div class="input-group-append">
                                                                        <div class="input-group-text">m2</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="Stepper3"
                                                                    class="field-label">{{ $t('devis.devis_habitation.EtagePiece.placeholder_nombrepiece') }}</label>
                                                                <select id="Stepper3" name="Step1" class="field-select"
                                                                    v-model="nombrepiece">
                                                                    <option v-for="item in Nombre" :key="item" :value="item"
                                                                        @click="Stepper1Validator">{{ item }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="wizard-card-footer clearfix mb-5">
                                    <div class="wizard-footer-left">
                                        <button @click="BackTolistHabitation()" type="button" class="wizard-btn">
                                            <span class="fas fa-arrow-left"></span>
                                            {{ $t('devis.devis_habitation.bouton_retour') }}
                                        </button>
                                    </div>
                                    <div class="wizard-footer-right">
                                        <button @click="Stepper1Validator()" type="button" class="wizard-btn">
                                            {{ $t('devis.devis_habitation.bouton_suivant') }}
                                        </button>
                                    </div>
                                    <!---->
                                </div>

                            </div>

                            <div class="page" v-show="step === 2">
                                <div class="wizard-tab-content">
                                    <div role="tabpanel" id="Step8" aria-hidden="true" aria-labelledby="step-Step8"
                                        class="wizard-tab-container">
                                        <div>
                                            <div class="loan-group loan-group-0">
                                                <div class="fields">
                                                    <div class="field-title font-weight-bold">
                                                        {{ $t('devis.devis_habitation.naturecouverture.detail_logement_title') }}&nbsp;:
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="Stepper24"
                                                                    class="field-label">{{ $t('devis.devis_habitation.naturecouverture.Headline') }}</label>
                                                                <select v-model="naturecouverture" id="Stepper24"
                                                                    name="Step8" class="field-select">
                                                                    <option v-for="item in items_toiture" :key="item"
                                                                        :value="item">{{ item }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default">
                                                                <label for="Stepper26"
                                                                    class="field-label">{{ $t('devis.devis_habitation.environnement_immediat.Headline') }}
                                                                </label>
                                                                <select v-model="environnement_immediat" id="Stepper26"
                                                                    name="Step8" class="field-select">
                                                                    <option v-for="item in items_environ_immediat"
                                                                        :key="item" :value="item">{{ item }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default">
                                                                <label for="Stepper27" class="field-label">
                                                                    {{ $t('devis.devis_habitation.Adresse_du_logement.Headline') }}
                                                                    <!---->
                                                                </label>
                                                                <div class="input-group value-loan">
                                                                    <input v-model="adresselogement" id="Stepper27"
                                                                        :placeholder="$t('devis.devis_habitation.Adresse_du_logement.placeholder')"
                                                                        name="Step8" class="field-input">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="wizard-card-footer clearfix mb-5">
                                    <div class="wizard-footer-left">
                                        <button @click="BacktoFirstStep()" type="button" class="wizard-btn">
                                            <span class="fas fa-arrow-left"></span>
                                            {{ $t('devis.devis_habitation.bouton_retour') }}
                                        </button>
                                    </div>
                                    <div class="wizard-footer-right">
                                        <button @click="Stepper2Validator()" type="button" class="wizard-btn">
                                            {{ $t('devis.devis_habitation.bouton_suivant') }}
                                        </button>
                                    </div>
                                    <!---->
                                </div>
                            </div>

                            <div class="page" v-show="step === 3">
                                <div class="wizard-tab-content">
                                    <div role="tabpanel" id="Step3" aria-labelledby="step-Step3"
                                        class="wizard-tab-container">
                                        <div>
                                            <div class="fields">
                                                <div class="field-title font-weight-bold">Propriétaire/Locataire&nbsp;:
                                                </div>
                                                <div class="field-group justify-content-center row flex-column flex-sm-row">
                                                    <div class="btn-choice btn-choice-icon sm-no-change">
                                                        <input v-model="qualiteassure"
                                                            :value="i18nFrHbitation.qualite_occupant.value_Locataire"
                                                            type="radio" id="Stepper3_1" name="Step3" class="field-input">
                                                        <label for="Stepper3_1" class="flex-row flex-md-column field-label">
                                                            <img src="../assets/img/icones/locataire.png"
                                                                class="mr-4 mr-md-0" alt="locataire">
                                                            <p class="text-center">
                                                                {{ $t('devis.devis_habitation.qualite_occupant.label_Locataire') }}
                                                            </p>
                                                        </label>
                                                    </div>
                                                    <div class="btn-choice btn-choice-icon sm-no-change ml-4">
                                                        <input v-model="qualiteassure" type="radio"
                                                            :value="i18nFrHbitation.qualite_occupant.value_Proprio_occupant"
                                                            id="Stepper3_2" name="Step3" class="field-input">
                                                        <label for="Stepper3_2" class="flex-row flex-md-column field-label">
                                                            <img src="../assets/img/icones/owner_habitation.png"
                                                                class="mr-4 mr-md-0" alt="owner_habitation">
                                                            <p class="text-center">
                                                                {{ $t('devis.devis_habitation.qualite_occupant.label_Proprio_occupant') }}
                                                            </p>
                                                        </label>
                                                    </div>
                                                    <div class="btn-choice btn-choice-icon sm-no-change ml-4">
                                                        <input v-model="qualiteassure" type="radio"
                                                            :value="i18nFrHbitation.qualite_occupant.value_Proprio_non_occupant"
                                                            id="Stepper3_3" name="Step3" class="field-input">
                                                        <label for="Stepper3_3" class="flex-row flex-md-column field-label">
                                                            <img src="../assets/img/icones/non_owner_habitation.png"
                                                                class="mr-4 mr-md-0" alt="non_owner_habitation">
                                                            <p class="text-center">
                                                                {{ $t('devis.devis_habitation.qualite_occupant.label_Proprio_non_occupant') }}
                                                            </p>
                                                        </label>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="wizard-tab-content"
                                    v-show="qualiteassure === i18nFrHbitation.qualite_occupant.value_Locataire">
                                    <div role="tabpanel" id="Step4" aria-hidden="true" aria-labelledby="step-Step4"
                                        class="wizard-tab-container">
                                        <div>
                                            <div class="loan-group loan-group-0">
                                                <div class="fields">
                                                    <div class="field-title font-weight-bold">
                                                        {{ $t('devis.devis_habitation.montantLoyer.Headline') }}&nbsp;:</div>
                                                    <div class="row">
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default">
                                                                <label for="Stepper4_1" class="field-label">
                                                                    {{ $t('devis.devis_habitation.montantLoyer.Headline') }}
                                                                    <!---->
                                                                </label>
                                                                <div class="input-group value-loan">
                                                                    <input v-money="money" v-model="montantLoyer"
                                                                        maxlength="11" id="Stepper4_1" name="Step4"
                                                                        class="field-input">
                                                                    <div class="input-group-append">
                                                                        <div class="input-group-text">FCFA</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="wizard-card-footer clearfix mb-5">
                                    <div class="wizard-footer-left">
                                        <button @click="BacktoSecondStep()" type="button" class="wizard-btn">
                                            <span class="fas fa-arrow-left"></span>
                                            {{ $t('devis.devis_habitation.bouton_retour') }}
                                        </button>
                                    </div>
                                    <div class="wizard-footer-right">
                                        <button @click="Stepper3Validator()" type="button" class="wizard-btn">
                                            {{ $t('devis.devis_habitation.bouton_suivant') }}
                                        </button>
                                    </div>
                                    <!---->
                                </div>

                            </div>

                            <div class="page" v-show="step === 4">
                                <div class="wizard-tab-content">
                                    <div role="tabpanel" id="Step4" aria-hidden="true" aria-labelledby="step-Step4"
                                        class="wizard-tab-container">
                                        <div>
                                            <div class="loan-group loan-group-0">
                                                <div class="fields">
                                                    <div class="field-title font-weight-bold">
                                                        {{ $t('devis.devis_habitation.valeurcontenu.valeur_contenu_title') }}&nbsp;:
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default">
                                                                <label for="Stepper5_1" class="field-label">
                                                                    {{ $t('devis.devis_habitation.valeurcontenu.Headline') }}
                                                                    <!---->
                                                                </label>
                                                                <div class="input-group value-loan">
                                                                    <input v-money="money" v-model="valeurcontenu"
                                                                        maxlength="11" id="Stepper5_1" name="Step4"
                                                                        class="field-input">
                                                                    <div class="input-group-append">
                                                                        <div class="input-group-text">FCFA</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default">
                                                                <label for="Stepper5_2" class="field-label">
                                                                    {{ $t('devis.devis_habitation.valeurbatiment.Headline') }}
                                                                    <!---->
                                                                </label>
                                                                <div class="input-group value-loan">
                                                                    <input v-model="valeurbatiment" id="Stepper5_2"
                                                                        maxlength="11" name="Step4" class="field-input"
                                                                        v-if="valeurbatiment">
                                                                    <input v-money="money" v-model="valeurbatiment"
                                                                        id="Stepper5_2" name="Step4" class="field-input"
                                                                        v-else>
                                                                    <div class="input-group-append">
                                                                        <div class="input-group-text">FCFA</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="wizard-card-footer clearfix mb-5">
                                    <div class="wizard-footer-left">
                                        <button @click="BacktoThirstStep()" type="button" class="wizard-btn">
                                            <span class="fas fa-arrow-left"></span>
                                            {{ $t('devis.devis_habitation.bouton_retour') }}
                                        </button>
                                    </div>
                                    <div class="wizard-footer-right">
                                        <button @click="Stepper4Validator()" type="button" class="wizard-btn">
                                            {{ $t('devis.devis_habitation.bouton_suivant') }}
                                        </button>
                                    </div>
                                    <!---->
                                </div>

                            </div>

                            <div class="page" v-show="step === 5">
                                <div class="wizard-tab-content">
                                    <div role="tabpanel" id="Step9" aria-hidden="true" aria-labelledby="step-Step9"
                                        class="wizard-tab-container">
                                        <div>
                                            <div class="fields">
                                                <div class="field-title font-weight-bold mb-0">
                                                    {{ $t('devis.devis_habitation.garanties_liste_title') }}&nbsp;:
                                                </div>
                                                <p class="field-sub-title mb-5">
                                                    {{ $t('devis.devis_habitation.garanties_liste_substitle') }}</p>
                                                <div class="field-title font-weight-bold">
                                                    {{ $t('devis.devis_habitation.GarantiesBaseTitre') }}&nbsp;:
                                                </div>
                                                <div class="field-group row field-bank">
                                                    <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                                        :data-tip="$t('devis.devis_habitation.Garanties[0].explications')"
                                                        tabindex="1">
                                                        <input type="checkbox" v-model="garanties"
                                                            :value="GarantiesBase[0].value" id="garantie_1" name="Step9"
                                                            class="field-input">
                                                        <label for="garantie_1" class="field-label">
                                                            <h3 class="mt-3 text-center">
                                                                <span>{{ $t('devis.devis_habitation.Garanties[0].label') }}</span>
                                                            </h3>
                                                        </label>
                                                    </div>
                                                    <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                                        :data-tip="$t('devis.devis_habitation.Garanties[1].explications')"
                                                        tabindex="1">
                                                        <input type="checkbox" v-model="garanties"
                                                            :value="GarantiesBase[1].value" id="garantie_2" name="Step9"
                                                            class="field-input">
                                                        <label for="garantie_2" class="field-label">
                                                            <h3 class="mt-3 text-center">
                                                                <span>{{ $t('devis.devis_habitation.Garanties[1].label') }}</span>
                                                            </h3>
                                                        </label>
                                                    </div>
                                                    <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                                        :data-tip="$t('devis.devis_habitation.Garanties[2].explications')"
                                                        tabindex="1">
                                                        <input type="checkbox" v-model="garanties"
                                                            :value="GarantiesBase[2].value" id="garantie_3" name="Step9"
                                                            class="field-input">
                                                        <label for="garantie_3" class="field-label">
                                                            <h3 class="mt-3 text-center">
                                                                <span>{{ $t('devis.devis_habitation.Garanties[2].label') }}</span>
                                                            </h3>
                                                        </label>
                                                    </div>
                                                    <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                                        :data-tip="$t('devis.devis_habitation.Garanties[3].explications')"
                                                        tabindex="1">
                                                        <input type="checkbox" v-model="garanties"
                                                            :value="GarantiesBase[3].value" id="garantie_4" name="Step9"
                                                            class="field-input">
                                                        <label for="garantie_4" class="field-label">
                                                            <h3 class="mt-3 text-center">
                                                                <span>{{ $t('devis.devis_habitation.Garanties[3].label') }}</span>
                                                            </h3>
                                                        </label>
                                                    </div>
                                                    <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                                        :data-tip="$t('devis.devis_habitation.Garanties[5].explications')"
                                                        tabindex="1">
                                                        <input type="checkbox" v-model="garanties"
                                                            :value="GarantiesBase[5].value" id="garantie_5" name="Step9"
                                                            class="field-input">
                                                        <label for="garantie_5" class="field-label">
                                                            <h3 class="mt-3 text-center">
                                                                <span>{{ $t('devis.devis_habitation.Garanties[5].label') }}</span>
                                                            </h3>
                                                        </label>
                                                    </div>
                                                    <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                                        :data-tip="$t('devis.devis_habitation.Garanties[4].explications')"
                                                        tabindex="1">
                                                        <input type="checkbox" v-model="garanties"
                                                            :value="GarantiesBase[4].value" id="garantie_6" name="Step9"
                                                            class="field-input" @change="volControl()">
                                                        <label for="garantie_6" class="field-label">
                                                            <h3 class="mt-3 text-center">
                                                                <span>{{ $t('devis.devis_habitation.Garanties[4].label') }}</span>
                                                            </h3>
                                                        </label>
                                                    </div>
                                                    <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                                        :data-tip="$t('devis.devis_habitation.Garanties[6].explications')"
                                                        tabindex="1">
                                                        <input type="checkbox" v-model="garanties"
                                                            :value="GarantiesBase[6].value" id="garantie_7" name="Step9"
                                                            class="field-input">
                                                        <label for="garantie_7" class="field-label">
                                                            <h3 class="mt-3 text-center">
                                                                <span>{{ $t('devis.devis_habitation.Garanties[6].label') }}</span>
                                                            </h3>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="fields">
                                                <div class="field-title font-weight-bold">
                                                    {{ $t('devis.devis_habitation.Autres_garanties_titre') }}&nbsp;:
                                                </div>
                                                <div class="field-group row field-bank">
                                                    <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                                        :data-tip="$t('devis.devis_habitation.Autres_garanties[0].explications')"
                                                        tabindex="1">
                                                        <input type="checkbox" v-model="garanties"
                                                            :value="Autres_garanties[0].value" id="garantie_8" name="Step9"
                                                            class="field-input">
                                                        <label for="garantie_8" class="field-label">
                                                            <h3 class="mt-3 text-center">
                                                                <span>{{ $t('devis.devis_habitation.Autres_garanties[0].label') }}</span>
                                                            </h3>
                                                        </label>
                                                    </div>
                                                    <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                                        :data-tip="$t('devis.devis_habitation.Autres_garanties[1].explications')"
                                                        tabindex="1">
                                                        <input type="checkbox" v-model="garanties"
                                                            :value="Autres_garanties[1].value" id="garantie_9" name="Step9"
                                                            class="field-input">
                                                        <label for="garantie_9" class="field-label">
                                                            <h3 class="mt-3 text-center">
                                                                <span>{{ $t('devis.devis_habitation.Autres_garanties[1].label') }}</span>
                                                            </h3>
                                                        </label>
                                                    </div>
                                                    <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                                        :data-tip="$t('devis.devis_habitation.Autres_garanties[2].explications')"
                                                        tabindex="1">
                                                        <input type="checkbox" v-model="garanties"
                                                            :value="Autres_garanties[2].value" id="garantie_10" name="Step9"
                                                            class="field-input">
                                                        <label for="garantie_10" class="field-label">
                                                            <h3 class="mt-3 text-center">
                                                                <span>{{ $t('devis.devis_habitation.Autres_garanties[2].label') }}</span>
                                                            </h3>
                                                        </label>
                                                    </div>
                                                    <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                                        :data-tip="$t('devis.devis_habitation.Autres_garanties[3].explications')"
                                                        tabindex="1">
                                                        <input type="checkbox" v-model="garanties"
                                                            :value="Autres_garanties[3].value" id="garantie_11" name="Step9"
                                                            class="field-input">
                                                        <label for="garantie_11" class="field-label">
                                                            <h3 class="mt-3 text-center">
                                                                <span>{{ $t('devis.devis_habitation.Autres_garanties[3].label') }}</span>
                                                            </h3>
                                                        </label>
                                                    </div>
                                                    <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                                        :data-tip="$t('devis.devis_habitation.Autres_garanties[5].explications')"
                                                        tabindex="1">
                                                        <input type="checkbox" v-model="garanties"
                                                            :value="Autres_garanties[5].value" id="garantie_13" name="Step9"
                                                            class="field-input" @change="volControl()">
                                                        <label for="garantie_13" class="field-label">
                                                            <h3 class="mt-3 text-center">
                                                                <span>{{ $t('devis.devis_habitation.Autres_garanties[5].label') }}</span>
                                                            </h3>
                                                        </label>
                                                    </div>
                                                    <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                                        :data-tip="$t('devis.devis_habitation.Autres_garanties[4].explications')"
                                                        tabindex="1">
                                                        <input type="checkbox" v-model="garanties"
                                                            :value="Autres_garanties[4].value" id="garantie_14" name="Step9"
                                                            class="field-input" @change="chech_scolarite()">
                                                        <label for="garantie_14" class="field-label">
                                                            <h3 class="mt-3 text-center">
                                                                <span>{{ $t('devis.devis_habitation.Autres_garanties[4].label') }}</span>
                                                            </h3>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="wizard-card-footer clearfix mb-5">
                                    <div class="wizard-footer-left">
                                        <button @click="BacktoFourStep()" type="button" class="wizard-btn">
                                            <span class="fas fa-arrow-left"></span>
                                            {{ $t('devis.devis_habitation.bouton_retour') }}
                                        </button>
                                    </div>
                                    <div class="wizard-footer-right">
                                        <button @click="Stepper5Validator()" type="button" class="wizard-btn">
                                            {{ $t('devis.devis_habitation.bouton_suivant') }}
                                        </button>
                                    </div>
                                </div>

                            </div>

                            <div class="page review_page" v-show="step === 6">
                                <div class="wizard-tab-content">
                                    <div role="tabpanel" id="Step10" aria-hidden="true" aria-labelledby="step-Step10"
                                        class="wizard-tab-container">
                                        <div>
                                            <div class="justify-content-center row field-title font-weight-bold"
                                                style="color:#ffa409">
                                                {{ $t('devis.devis_habitation.HeadLineSteper_6') }}
                                            </div>
                                            <div class="field-title font-weight-bold">
                                                {{ $t('devis.devis_habitation.subHeadlineSteper_6') }}&nbsp;:
                                            </div>
                                            <div class="fields" v-for="(item, index) in listHabitat" :key="index">
                                                <div class="field-group row align-items-center">
                                                    <div class="col-lg-4"><label for="Stepper29"
                                                            class="field-label">{{ $t('devis.devis_habitation.entetTableeauRec[0]') }}</label>
                                                    </div>
                                                    <div class="col-lg-8 field-default">
                                                        <input disabled type="text" id="Stepper29" name="Step10"
                                                            :value="item.typeBien" class="field-input pac-target-input">
                                                        <div class="field-error">
                                                            <!---->
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="field-group row align-items-center">
                                                    <div class="col-lg-4"><label for="Stepper30"
                                                            class="field-label">{{ $t('devis.devis_habitation.entetTableeauRec[1]') }}</label>
                                                    </div>
                                                    <div class="col-lg-8 field-default">
                                                        <input disabled type="text" id="Stepper30" name="Step10"
                                                            :value="item.nombrepiece" class="field-input pac-target-input">
                                                        <div class="field-error">
                                                            <!---->
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="field-group row align-items-center">
                                                    <div class="col-lg-4"><label for="Stepper31"
                                                            class="field-label">{{ $t('devis.devis_habitation.entetTableeauRec[2]') }}</label>
                                                    </div>
                                                    <div class="col-lg-8 field-default">
                                                        <input disabled type="tel" id="Stepper31" name="Step10"
                                                            :value="item.nombreetage" class="field-input">
                                                        <div class="field-error">
                                                            <!---->
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="field-group row align-items-center">
                                                    <div class="col-lg-4"><label for="Stepper32"
                                                            class="field-label">{{ $t('devis.devis_habitation.entetTableeauRec[3]') }}</label>
                                                    </div>
                                                    <div class="col-lg-8 field-default">
                                                        <input disabled type="text" id="Stepper32" name="Step10"
                                                            :value="item.naturecouverture" class="field-input">
                                                        <div class="field-error">
                                                            <!---->
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="field-group row align-items-center">
                                                    <div class="col-lg-4"><label for="Stepper33"
                                                            class="field-label">{{ $t('devis.devis_habitation.entetTableeauRec[4]') }}</label>
                                                    </div>
                                                    <div class="col-lg-8 field-default">
                                                        <input disabled type="text" id="Stepper33" name="Step10"
                                                            :value="item.adresselogement" class="field-input">
                                                        <div class="field-error">
                                                            <!---->
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="field-group row align-items-center">
                                                    <div class="col-lg-4"><label for="Stepper34"
                                                            class="field-label">{{ $t('devis.devis_habitation.entetTableeauRec[5]') }}</label>
                                                    </div>
                                                    <div class="col-lg-8 field-default">
                                                        <input disabled type="text" id="Stepper34" name="Step10"
                                                            :value="item.valeurcontenu" class="field-input">
                                                        <div class="field-error">
                                                            <!---->
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="field-group row align-items-center">
                                                    <div class="col-lg-4"><label for="Stepper35"
                                                            class="field-label">{{ $t('devis.devis_habitation.entetTableeauRec[6]') }}</label>
                                                    </div>
                                                    <div class="col-lg-8 field-default">
                                                        <input disabled type="text" id="Stepper35" name="Step10"
                                                            :value="item.valeurbatiment" class="field-input">
                                                        <div class="field-error">
                                                            <!---->
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="field-group row align-items-center">
                                                    <div class="col-lg-4"><label for="Stepper36"
                                                            class="field-label">{{ $t('devis.devis_habitation.entetTableeauRec[7]') }}</label>
                                                    </div>
                                                    <div class="col-lg-8 field-default">
                                                        <input disabled type="text" id="Stepper36" name="Step10"
                                                            :value="item.qualiteassure" class="field-input">
                                                        <div class="field-error">
                                                            <!---->
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="field-group row align-items-center">
                                                    <div class="col-lg-4"><label for="Stepper37"
                                                            class="field-label">{{ $t('devis.devis_habitation.entetTableeauRec[8]') }}</label>
                                                    </div>
                                                    <div class="col-lg-8 field-default">
                                                        <input style="margin-bottom:4px"
                                                            v-for="(garantie, index) in item.garanties" :key="index"
                                                            disabled type="text" id="Stepper37" name="Step10"
                                                            :value="garantie" class="field-input">
                                                    </div>
                                                </div>
                                                <div class="wizard-card-footer clearfix">
                                                    <div class="wizard-footer-left">
                                                    </div>
                                                    <div class="wizard-footer-right">
                                                        <button @click="editHabitat(item)" type="button"
                                                            class="mr-5 wizard-btn">
                                                            {{ $t('devis.devis_habitation.bouton_modifier') }}
                                                        </button>
                                                        <button @click="AddGaranties(item)" type="button"
                                                            class="wizard-btn">
                                                            {{ $t('devis.devis_habitation.bouton_ajouter_garanties') }}
                                                        </button>
                                                    </div>
                                                    <!---->
                                                </div>
                                            </div>


                                            <div class="fields">
                                                <div class="field-title font-weight-bold">
                                                    {{ $t('devis.devis_habitation.choix_assureurs') }}&nbsp;:
                                                </div>
                                                 <!-- Grid moderne pour les assureurs -->
            <div class="insurers-grid">
                <!-- Bouton "Tous" -->
                <div class="insurer-card all-insurers" :class="{ 'selected': selectAll }">
                <input v-model="selectAll" type="checkbox" id="tous_mobile" class="insurer-input">
                <label for="tous_mobile" class="insurer-label">
                    <div class="insurer-icon">
                    <img src="../assets/img/icones/all.png" alt="Tous les assureurs" class="insurer-logo">
                    </div>
                    <div class="insurer-info">
                    <h4 class="insurer-name">{{ $t('devis.devis_auto.bouton_tous') }}</h4>
                    <span class="insurer-badge">Tous</span>
                    </div>
                    <div class="selection-indicator">
                    <i class="fas fa-check"></i>
                    </div>
                </label>
                </div>

                <!-- Cartes des assureurs -->
                <div 
                class="insurer-card" 
                v-for="assure in listeAssureurs" 
                :key="assure._id"
                :class="{ 'selected': assureurs.includes(assure.societe) }"
                >
                <input 
                    v-model="assureurs" 
                    type="checkbox" 
                    :value="assure.societe" 
                    :id="assure.societe"
                    class="insurer-input"
                >
                <label :for="assure.societe" class="insurer-label">
                    <div class="insurer-icon">
                    <img :src="assure.logo" :alt="assure.societe" class="insurer-logo">
                    </div>
                    <div class="insurer-info">
                    <h4 class="insurer-name">{{ assure.societe }}</h4>
                    <span class="insurer-badge">Assureur</span>
                    </div>
                    <div class="selection-indicator">
                    <i class="fas fa-check"></i>
                    </div>
                </label>
                </div>
            </div>

            <!-- Résumé de la sélection -->
            <div class="selection-summary" v-if="assureurs.length > 0">
                <div class="summary-content">
                <i class="fas fa-info-circle"></i>
                <span>{{ assureurs.length }} {{ $t('devis.devis_auto.assureur_label') }}{{ assureurs.length > 1 ? 's' : '' }} {{ $t('devis.devis_auto.selectionne_label') }}{{ assureurs.length > 1 ? 's' : '' }}</span>
                </div>
            </div>

                                                <!-- <div class="field-group row field-bank">
                                                    <div class="btn-choice col-sm-3 col-4">
                                                        <input v-model="selectAll" type="checkbox" id="tous"
                                                            class="field-input">
                                                        <label for="tous" class="field-label" label="Tous">
                                                            <img src="../assets/img/icones/all.png" alt="tous"
                                                                height="60" width="30">
                                                            <p class="field-title"
                                                                style="margin-top:-14px;margin-bottom:-10px;color:#ffa409">
                                                                {{ $t('devis.devis_habitation.tous_title') }}</p>
                                                        </label>
                                                    </div>
                                                    <div class="btn-choice col-sm-3 col-4" v-for="assure in listeAssureurs"
                                                        :key="assure._id">
                                                        <input v-model="assureurs" type="checkbox" :value="assure.societe"
                                                            :id="assure.societe" class="field-input">
                                                        <label :for="assure.societe" class="field-label"
                                                            :label="assure.societe">
                                                            <img :src="assure.logo" :alt="assure.societe" height="50">
                                                            <p class="field-title"
                                                                style="margin-top:-3px;margin-bottom:-10px">
                                                                {{ assure.societe }}</p>
                                                        </label>
                                                    </div>
                                                </div> -->
                                            </div>
                                        </div>
                                    </div>

                                    <div role="tabpanel" id="Step11" aria-hidden="true" aria-labelledby="step-Step11"
                                        class="wizard-tab-container">
                                        <div>
                                            <div class="loan-group loan-group-0">
                                                <div class="fields">
                                                    <div class="field-title font-weight-bold">
                                                        {{ $t('devis.devis_habitation.periode') }}&nbsp;:</div>
                                                    <div class="row">
                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="Stepper38"
                                                                    class="field-label">{{ $t('devis.devis_habitation.duree_garantie') }}
                                                                    <button type="button" tabindex="-1" title=""
                                                                        class="field-help"
                                                                        data-original-title="Taux d'intérêt"></button></label>
                                                                <div class="input-group rate-loan">
                                                                    <input @keypress="onlyNumber" min="1" max="12"
                                                                        type="number" id="Stepper38"
                                                                        placeholder="Durée de la garantie" name="Step11"
                                                                        class="field-input" v-model="duree_contrat"
                                                                        @keyup="dateDiff" disabled @change="numberMonth()">
                                                                    <div class="input-group-append">
                                                                        <div class="input-group-text">
                                                                            {{ $t('devis.devis_habitation.mois') }}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="Stepper39"
                                                                    class="field-label">{{ $t('devis.devis_habitation.date_effet') }}
                                                                    <button type="button" tabindex="-1" title=""
                                                                        class="field-help"
                                                                        data-original-title="Taux d'intérêt"></button></label>
                                                                <div class="input-group rate-loan">
                                                                    <date-picker id="Stepper39"
                                                                        :disabled-date="disabledAfterToday"
                                                                        class="field-input ml-2 mb-1 mt-1"
                                                                        placeholder="Cliquer ici" @change="dateDiff()"
                                                                        :min="new Date().toISOString().substr(0, 10)"
                                                                        v-model="dateEffet" valueType="format"
                                                                        format="YYYY-MM-DD" lang="fr-fr"></date-picker>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-sm-4">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="Stepper40"
                                                                    class="field-label">{{ $t('devis.devis_habitation.date_echeance') }}
                                                                    <button type="button" tabindex="-1" title=""
                                                                        class="field-help"
                                                                        data-original-title="Taux d'intérêt"></button></label>
                                                                <div class="input-group rate-loan">
                                                                    <input disabled placeholder="Date d'échéance"
                                                                        v-model="dateEcheance" id="Stepper40" name="Step11"
                                                                        class="field-input">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div role="tabpanel" id="Step12" aria-hidden="true" aria-labelledby="step-Step12"
                                        class="wizard-tab-container">
                                        <div>
                                            <div class="loan-group loan-group-0">
                                                <div class="fields">
                                                    <div class="field-title font-weight-bold">
                                                        {{ $t('devis.devis_habitation.beneficiaire') }}&nbsp;:</div>
                                                    <div class="row">
                                                        <div class="col-sm-4 mt-5">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <div class="field-checkbox">
                                                                    <div class="field-label">
                                                                        {{ $t('devis.devis_habitation.idem_compte_connecte') }}
                                                                    </div>
                                                                    <div class="switch">
                                                                        <label for="Stepper41">
                                                                            <input @change="switchBenef()" v-model="switch1"
                                                                                type="checkbox" id="Stepper41"
                                                                                name="Step12">
                                                                            <span class="lever"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-sm-6">
                                                            <div class="field-group field-default mb-4 mb-sm-0">
                                                                <label for="Stepper42"
                                                                    class="field-label">{{ $t('devis.devis_habitation.prenom_nom') }}
                                                                    <button type="button" tabindex="-1" title=""
                                                                        class="field-help"
                                                                        data-original-title="Taux d'intérêt"></button></label>
                                                                <div class="input-group rate-loan">
                                                                    <input :disabled="disabledBenefInput" @click="dialogInfoBeneficiaire = true" :placeholder="$t('devis.devis_auto.nom_et_prenom')"
                                                                        v-model="proprietaire" id="Stepper42" name="Step12"
                                                                        class="field-input">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="wizard-card-footer clearfix mb-5">
                                    <div class="wizard-footer-left">
                                        <button @click="BacktoFiveStep()" type="button" class="wizard-btn">
                                            <span class="fas fa-arrow-left"></span>
                                            {{ $t('devis.devis_habitation.bouton_retour') }}
                                        </button>
                                    </div>
                                    <div class="wizard-footer-right">
                                        <button :disabled="disabledButtonValidate" @click="Stepper6Validator()"
                                            type="button" class="wizard-btn">
                                            {{ $t('devis.devis_habitation.bouton_valider') }}
                                        </button>
                                    </div>
                                    <!---->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE     ================= -->
                <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
                <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
                <!-- ========================================================================================= -->
                <div v-responsive.sm.xs>
                    <div class="mt-5" style="margin-bottom:8%;background:#FAFAFA">
                        <div class="row" style="background:#FAFAFA">

                            <div class="col-md-10" style="background:#FAFAFA">
                                <div class="form" style="background:#FAFAFA">
                                    <div class="page" v-show="step === 0">
                                        <div class="wizard-tab-content">
                                            <div role="tabpanel" id="Step1_mobile" aria-labelledby="step-Step1_mobile"
                                                class="wizard-tab-container">
                                                <div>
                                                    <div class="fields">
                                                        <div class="field-title">{{
                                                            $t('devis.devis_habitation.stepper_one_subtitle_one') }}&nbsp;:
                                                        </div>
                                                        <div
                                                            class="field-group justify-content-center row flex-column flex-sm-row">
                                                            <div class="btn-choice btn-choice-icon sm-no-change">
                                                                <input :disabled="disabledMyHabitation"
                                                                    v-model="myHabitations" value="mes_habitations"
                                                                    type="radio" id="Stepper1_1_2_mobile"
                                                                    name="Step1_mobile" @click="getListHabitation"
                                                                    class="field-input">
                                                                <label for="Stepper1_1_2_mobile"
                                                                    class="flex-row flex-md-column field-label">
                                                                    <img src="../assets/img/icones/myhomes.png"
                                                                        class="mr-4 mr-md-0" alt="myhomes">
                                                                    <p>{{ $t('devis.devis_habitation.my_logement') }}</p>
                                                                </label>
                                                            </div>
                                                            <div class="btn-choice btn-choice-icon sm-no-change">
                                                                <input v-model="myHabitations" type="radio" value="nouveau"
                                                                    id="Stepper2_2_3_mobile" name="Step1_mobile"
                                                                    class="field-input" @change="myHabitationValidator()">
                                                                <label for="Stepper2_2_3_mobile"
                                                                    class="flex-row flex-md-column field-label">
                                                                    <img src="../assets/img/icones/newhome.png"
                                                                        class="mr-4 mr-md-0" alt="newhome">
                                                                    <p>{{ $t('devis.devis_habitation.new_logement') }}</p>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="page" v-show="step === 1">
                                        <div class="wizard-tab-content">
                                            <div role="tabpanel" id="Step1_mobile" aria-labelledby="step-Step1_mobile"
                                                class="wizard-tab-container">
                                                <div>
                                                    <div class="fields">
                                                        <div class="field-title">{{
                                                            $t('devis.devis_habitation.stepper_two_subtitle_two') }}&nbsp;:
                                                        </div>
                                                        <div
                                                            class="field-group justify-content-center row flex-column flex-sm-row">
                                                            <div class="btn-choice btn-choice-icon sm-no-change">
                                                                <input v-model="naturelogement"
                                                                    :value="i18nFrHbitation.natureLogement.labelAppartement_value"
                                                                    type="radio" id="Stepper1_mobile" name="Step1_mobile"
                                                                    class="field-input">
                                                                <label for="Stepper1_mobile"
                                                                    class="flex-row flex-md-column field-label">
                                                                    <img src="../assets/img/icones/appartments.png"
                                                                        class="mr-4 mr-md-0" alt="appartements">
                                                                    <p>{{
                                                                        $t('devis.devis_habitation.natureLogement.labelAppartement_label')
                                                                    }}</p>
                                                                </label>
                                                            </div>
                                                            <div class="btn-choice btn-choice-icon sm-no-change">
                                                                <input v-model="naturelogement" type="radio"
                                                                    :value="i18nFrHbitation.natureLogement.labelMaison_value"
                                                                    id="Stepper2_mobile" name="Step1_mobile"
                                                                    class="field-input">
                                                                <label for="Stepper2_mobile"
                                                                    class="flex-row flex-md-column field-label">
                                                                    <img src="../assets/img/icones/home.png"
                                                                        class="mr-4 mr-md-0" alt="home">
                                                                    <p>{{
                                                                        $t('devis.devis_habitation.natureLogement.labelMaison_label')
                                                                    }}</p>
                                                                </label>
                                                            </div>

                                                            <div class="btn-choice btn-choice-icon sm-no-change">
                                                                <input v-model="naturelogement" type="radio"
                                                                    :value="i18nFrHbitation.natureLogement.labelImmeuble_value"
                                                                    id="Stepper3_mobile" name="Step1_mobile"
                                                                    class="field-input">
                                                                <label for="Stepper3_mobile"
                                                                    class="flex-row flex-md-column field-label">
                                                                    <img src="../assets/img/icones/immeuble.png"
                                                                        class="mr-4 mr-md-0" alt="immeuble">
                                                                    <p>{{
                                                                        $t('devis.devis_habitation.natureLogement.labelImmeuble_label')
                                                                    }}</p>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="fields">
                                                        <div class="field-title">{{
                                                            $t('devis.devis_habitation.EtagePiece.superficie_title')
                                                        }}&nbsp;:</div>
                                                        <div class="field-group field-default mt-3 mb-4 mb-sm-0">
                                                            <label for="Stepper28_mobile" class="field-label">{{
                                                                $t('devis.devis_habitation.EtagePiece.placeholder_nombreetage')
                                                            }}</label>
                                                            <div class="input-group value-loan">
                                                                <input @keypress="onlyNumber" v-model="nombreetage"
                                                                    placeholder="Superficie (en m2)" id="Stepper28_mobile"
                                                                    name="Step8" class="field-input">
                                                                <div class="input-group-append">
                                                                    <div class="input-group-text">m2</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                            <label for="Stepper3_mobile"
                                                                class="field-label">{{ $t('devis.devis_habitation.EtagePiece.placeholder_nombrepiece') }}</label>
                                                            <select id="Stepper3_mobile" name="Step1_mobile"
                                                                class="field-select" v-model="nombrepiece">
                                                                <option v-for="item in Nombre" :key="item" :value="item"
                                                                    @change="Stepper1Validator">{{ item }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="wizard-card-footer clearfix">
                                            <div class="wizard-footer-left">
                                                <button @click="BackTolistHabitation()" type="button" class="wizard-btn">
                                                    <span class="fas fa-arrow-left"></span>
                                                    {{ $t('devis.devis_habitation.bouton_retour') }}
                                                </button>
                                            </div>
                                            <div class="wizard-footer-right">
                                                <button @click="Stepper1Validator()" type="button" class="wizard-btn">
                                                    {{ $t('devis.devis_habitation.bouton_suivant') }}
                                                </button>
                                            </div>
                                            <!---->
                                        </div>

                                    </div>

                                    <div class="page" v-show="step === 2">
                                        <div class="wizard-tab-content">
                                            <div role="tabpanel" id="Step8_mobile" aria-hidden="true"
                                                aria-labelledby="step-Step8_mobile" class="wizard-tab-container">
                                                <div>
                                                    <div class="loan-group loan-group-0">
                                                        <div class="fields">
                                                            <div class="field-title">
                                                                {{ $t('devis.devis_habitation.naturecouverture.detail_logement_title') }}&nbsp;:
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-sm-4">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="Stepper24_mobile"
                                                                            class="field-label">{{ $t('devis.devis_habitation.naturecouverture.Headline') }}</label>
                                                                        <select v-model="naturecouverture"
                                                                            id="Stepper24_mobile" name="Step8_mobile"
                                                                            class="field-select">
                                                                            <option v-for="item in items_toiture"
                                                                                :key="item" :value="item">{{ item }}</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-4">
                                                                    <div class="field-group field-default mt-3">
                                                                        <label for="Stepper26_mobile"
                                                                            class="field-label">{{ $t('devis.devis_habitation.environnement_immediat.Headline') }}
                                                                        </label>
                                                                        <select v-model="environnement_immediat"
                                                                            id="Stepper26_mobile" name="Step8_mobile"
                                                                            class="field-select">
                                                                            <option v-for="item in items_environ_immediat"
                                                                                :key="item" :value="item">{{ item }}</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-4">
                                                                    <div
                                                                        class="field-group field-default mt-3 mb-4 mb-sm-0">
                                                                        <label for="Stepper28_mobile"
                                                                            class="field-label">{{ $t('devis.devis_habitation.Adresse_du_logement.Headline') }}</label>
                                                                        <input v-model="adresselogement"
                                                                            id="Stepper28_mobile" name="Step8_mobile"
                                                                            class="field-input">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="wizard-card-footer clearfix">
                                            <div class="wizard-footer-left">
                                                <button @click="BacktoFirstStep()" type="button" class="wizard-btn">
                                                    <span class="fas fa-arrow-left"></span>
                                                    {{ $t('devis.devis_habitation.bouton_retour') }}
                                                </button>
                                            </div>
                                            <div class="wizard-footer-right">
                                                <button @click="Stepper2Validator()" type="button" class="wizard-btn">
                                                    {{ $t('devis.devis_habitation.bouton_suivant') }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="page" v-show="step === 3">
                                        <div class="wizard-tab-content">
                                            <div role="tabpanel" id="Step3_mobile" aria-labelledby="step-Step3_mobile"
                                                class="wizard-tab-container">
                                                <div>
                                                    <div class="fields">
                                                        <div class="field-title">Propriétaire/Locataire&nbsp;:</div>
                                                        <div
                                                            class="field-group justify-content-center row flex-column flex-sm-row">
                                                            <div class="btn-choice btn-choice-icon sm-no-change">
                                                                <input v-model="qualiteassure"
                                                                    :value="i18nFrHbitation.qualite_occupant.value_Locataire"
                                                                    type="radio" id="Stepper3_1_mobile" name="Step1_mobile"
                                                                    class="field-input">
                                                                <label for="Stepper3_1_mobile"
                                                                    class="flex-row flex-md-column field-label">
                                                                    <img src="../assets/img/icones/locataire.png"
                                                                        class="mr-4 mr-md-0" alt="locataire">
                                                                    <p>{{ $t('devis.devis_habitation.qualite_occupant.label_Locataire') }}
                                                                    </p>
                                                                </label>
                                                            </div>
                                                            <div class="btn-choice btn-choice-icon sm-no-change">
                                                                <input v-model="qualiteassure" type="radio"
                                                                    :value="i18nFrHbitation.qualite_occupant.value_Proprio_occupant"
                                                                    id="Stepper3_2_mobile" name="Step1_mobile"
                                                                    class="field-input">
                                                                <label for="Stepper3_2_mobile"
                                                                    class="flex-row flex-md-column field-label">
                                                                    <img src="../assets/img/icones/owner_habitation.png"
                                                                        class="mr-4 mr-md-0" alt="owner_habitation">
                                                                    <p>{{ $t('devis.devis_habitation.qualite_occupant.label_Proprio_occupant') }}
                                                                    </p>
                                                                </label>
                                                            </div>

                                                            <div class="btn-choice btn-choice-icon sm-no-change">
                                                                <input v-model="qualiteassure" type="radio"
                                                                    :value="i18nFrHbitation.qualite_occupant.value_Proprio_non_occupant"
                                                                    id="Stepper3_3_mobile" name="Step1_mobile"
                                                                    class="field-input">
                                                                <label for="Stepper3_3_mobile"
                                                                    class="flex-row flex-md-column field-label">
                                                                    <img src="../assets/img/icones/non_owner_habitation.png"
                                                                        class="mr-4 mr-md-0" alt="non_owner_habitation">
                                                                    <p>{{ $t('devis.devis_habitation.qualite_occupant.label_Proprio_non_occupant') }}
                                                                    </p>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="wizard-tab-content"
                                            v-show="qualiteassure === i18nFrHbitation.qualite_occupant.value_Locataire">
                                            <div role="tabpanel" id="Step4_mobile" aria-hidden="true"
                                                aria-labelledby="step-Step4_mobile" class="wizard-tab-container">
                                                <div>
                                                    <div class="loan-group loan-group-0">
                                                        <div class="fields">
                                                            <div class="field-title">
                                                                {{ $t('devis.devis_habitation.montantLoyer.Headline') }}&nbsp;:
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-sm-6">
                                                                    <div class="field-group field-default">
                                                                        <label for="Stepper4_1_mobile" class="field-label">
                                                                            {{ $t('devis.devis_habitation.montantLoyer.Headline') }}
                                                                            <!---->
                                                                        </label>
                                                                        <div class="input-group value-loan">
                                                                            <input v-money="money" v-model="montantLoyer"
                                                                                maxlength="11" id="Stepper4_1_mobile"
                                                                                name="Step4_mobile" class="field-input">
                                                                            <div class="input-group-append">
                                                                                <div class="input-group-text">FCFA</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="wizard-card-footer clearfix">
                                            <div class="wizard-footer-left">
                                                <button @click="BacktoSecondStep()" type="button" class="wizard-btn">
                                                    <span class="fas fa-arrow-left"></span>
                                                    {{ $t('devis.devis_habitation.bouton_retour') }}
                                                </button>
                                            </div>
                                            <div class="wizard-footer-right">
                                                <button @click="Stepper3Validator()" type="button" class="wizard-btn">
                                                    {{ $t('devis.devis_habitation.bouton_suivant') }}
                                                </button>
                                            </div>
                                            <!---->
                                        </div>

                                    </div>

                                    <div class="page" v-show="step === 4">
                                        <div class="wizard-tab-content">
                                            <div role="tabpanel" id="Step4_mobile" aria-hidden="true"
                                                aria-labelledby="step-Step4_mobile" class="wizard-tab-container">
                                                <div>
                                                    <div class="loan-group loan-group-0">
                                                        <div class="fields">
                                                            <div class="field-title">
                                                                {{ $t('devis.devis_habitation.valeurcontenu.valeur_contenu_title') }}&nbsp;:
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-sm-6">
                                                                    <div class="field-group field-default">
                                                                        <label for="Stepper5_1_mobile" class="field-label">
                                                                            {{ $t('devis.devis_habitation.valeurcontenu.Headline') }}
                                                                            <!---->
                                                                        </label>
                                                                        <div class="input-group value-loan">
                                                                            <input v-money="money" v-model="valeurcontenu"
                                                                                maxlength="11" id="Stepper5_1_mobile"
                                                                                name="Step4_mobile" class="field-input">
                                                                            <div class="input-group-append">
                                                                                <div class="input-group-text">FCFA</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-6">
                                                                    <div class="field-group field-default">
                                                                        <label for="Stepper5_2_mobile" class="field-label">
                                                                            {{ $t('devis.devis_habitation.valeurbatiment.Headline') }}
                                                                            <!---->
                                                                        </label>
                                                                        <div class="input-group value-loan">
                                                                            <input v-model="valeurbatiment"
                                                                                id="Stepper5_2_mobile" maxlength="11"
                                                                                name="Step4_mobile" class="field-input"
                                                                                v-if="valeurbatiment">
                                                                            <input v-money="money" v-model="valeurbatiment"
                                                                                id="Stepper5_2_mobile" name="Step4_mobile"
                                                                                class="field-input" v-else>
                                                                            <div class="input-group-append">
                                                                                <div class="input-group-text">FCFA</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="wizard-card-footer clearfix">
                                            <div class="wizard-footer-left">
                                                <button @click="BacktoThirstStep()" type="button" class="wizard-btn">
                                                    <span class="fas fa-arrow-left"></span>
                                                    {{ $t('devis.devis_habitation.bouton_retour') }}
                                                </button>
                                            </div>
                                            <div class="wizard-footer-right">
                                                <button @click="Stepper4Validator()" type="button" class="wizard-btn">
                                                    {{ $t('devis.devis_habitation.bouton_suivant') }}
                                                </button>
                                            </div>
                                            <!---->
                                        </div>
                                    </div>

                                    <div class="page" v-show="step === 5">
                                        <div class="wizard-tab-content">
                                            <div role="tabpanel" id="Step9_mobile" aria-hidden="true"
                                                aria-labelledby="step-Step9_mobile" class="wizard-tab-container">
                                                <div>
                                                    <div class="fields">
                                                        <div class="field-title mb-0">
                                                            {{ $t('devis.devis_habitation.garanties_liste_title') }}&nbsp;:
                                                        </div>
                                                        <p class="field-sub-title mb-5">
                                                            {{ $t('devis.devis_habitation.garanties_liste_substitle') }}</p>
                                                        <div class="field-title">
                                                            {{ $t('devis.devis_habitation.GarantiesBaseTitre') }}&nbsp;:
                                                        </div>
                                                        <div class="field-group row field-bank"
                                                            v-show="categorie != '2_roues'">
                                                            <div class="btn-choice sm-no-change col-sm-6">
                                                                <input type="checkbox" v-model="garanties"
                                                                    :value="GarantiesBase[0].value" id="garantie_2_mobile"
                                                                    name="Step9_mobile" class="field-input">
                                                                <label for="garantie_2_mobile" class="field-label">
                                                                    <h5 class="mt-3 text-center">
                                                                        {{ $t('devis.devis_habitation.Garanties[0].label') }}
                                                                    </h5>
                                                                </label>
                                                            </div>
                                                            <div class="btn-choice sm-no-change col-sm-6">
                                                                <input type="checkbox" v-model="garanties"
                                                                    :value="GarantiesBase[1].value" id="garantie_3_mobile"
                                                                    name="Step9_mobile" class="field-input">
                                                                <label for="garantie_3_mobile" class="field-label">
                                                                    <h3 class="mt-3 text-center">
                                                                        {{ $t('devis.devis_habitation.Garanties[1].label') }}
                                                                    </h3>
                                                                </label>
                                                            </div>
                                                            <div class="btn-choice sm-no-change col-sm-6">
                                                                <input type="checkbox" v-model="garanties"
                                                                    :value="GarantiesBase[2].value" id="garantie_4_mobile"
                                                                    name="Step9_mobile" class="field-input">
                                                                <label for="garantie_4_mobile" class="field-label">
                                                                    <h3 class="mt-3 text-center">
                                                                        {{ $t('devis.devis_habitation.Garanties[2].label') }}
                                                                    </h3>
                                                                </label>
                                                            </div>
                                                            <div class="btn-choice sm-no-change col-sm-6">
                                                                <input type="checkbox" v-model="garanties"
                                                                    :value="GarantiesBase[3].value" id="garantie_5_mobile"
                                                                    name="Step9_mobile" class="field-input">
                                                                <label for="garantie_5_mobile" class="field-label">
                                                                    <h3 class="mt-3 text-center">
                                                                        {{ $t('devis.devis_habitation.Garanties[3].label') }}
                                                                    </h3>
                                                                </label>
                                                            </div>
                                                            <div class="btn-choice sm-no-change col-sm-6">
                                                                <input type="checkbox" v-model="garanties"
                                                                    :value="GarantiesBase[5].value" id="garantie_6_mobile"
                                                                    name="Step9_mobile" class="field-input">
                                                                <label for="garantie_6_mobile" class="field-label">
                                                                    <h3 class="mt-3 text-center">
                                                                        {{ $t('devis.devis_habitation.Garanties[5].label') }}
                                                                    </h3>
                                                                </label>
                                                            </div>
                                                            <div class="btn-choice sm-no-change col-sm-6">
                                                                <input type="checkbox" v-model="garanties"
                                                                    :value="GarantiesBase[4].value" id="garantie_7_mobile"
                                                                    name="Step9_mobile" class="field-input">
                                                                <label for="garantie_7_mobile" class="field-label">
                                                                    <h3 class="mt-3 text-center">
                                                                        {{ $t('devis.devis_habitation.Garanties[4].label') }}
                                                                    </h3>
                                                                </label>
                                                            </div>
                                                            <div class="btn-choice sm-no-change col-sm-6">
                                                                <input type="checkbox" v-model="garanties"
                                                                    :value="GarantiesBase[6].value" id="garantie_8_mobile"
                                                                    name="Step9_mobile" class="field-input">
                                                                <label for="garantie_8_mobile" class="field-label">
                                                                    <h3 class="mt-3 text-center">
                                                                        {{ $t('devis.devis_habitation.Garanties[6].label') }}
                                                                    </h3>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="fields">
                                                        <div class="field-title">
                                                            {{ $t('devis.devis_habitation.Autres_garanties_titre') }}&nbsp;:
                                                        </div>
                                                        <div class="field-group row field-bank">
                                                            <div class="btn-choice sm-no-change col-sm-6">
                                                                <input type="checkbox" v-model="garanties"
                                                                    :value="Autres_garanties[0].value"
                                                                    id="garantie_9_mobile" name="Step9_mobile"
                                                                    class="field-input">
                                                                <label for="garantie_9_mobile" class="field-label">
                                                                    <h5 class="mt-3 text-center">
                                                                        {{ $t('devis.devis_habitation.Autres_garanties[0].label') }}
                                                                    </h5>
                                                                </label>
                                                            </div>
                                                            <div class="btn-choice sm-no-change col-sm-6">
                                                                <input type="checkbox" v-model="garanties"
                                                                    :value="Autres_garanties[1].value"
                                                                    id="garantie_10_mobile" name="Step9_mobile"
                                                                    class="field-input">
                                                                <label for="garantie_10_mobile" class="field-label">
                                                                    <h3 class="mt-3 text-center">
                                                                        {{ $t('devis.devis_habitation.Autres_garanties[1].label') }}
                                                                    </h3>
                                                                </label>
                                                            </div>
                                                            <div class="btn-choice sm-no-change col-sm-6">
                                                                <input type="checkbox" v-model="garanties"
                                                                    :value="Autres_garanties[2].value"
                                                                    id="garantie_11_mobile" name="Step9_mobile"
                                                                    class="field-input">
                                                                <label for="garantie_11_mobile" class="field-label">
                                                                    <h3 class="mt-3 text-center">
                                                                        {{ $t('devis.devis_habitation.Autres_garanties[2].label') }}
                                                                    </h3>
                                                                </label>
                                                            </div>
                                                            <div class="btn-choice sm-no-change col-sm-6">
                                                                <input type="checkbox" v-model="garanties"
                                                                    :value="Autres_garanties[3].value"
                                                                    id="garantie_12_mobile" name="Step9_mobile"
                                                                    class="field-input">
                                                                <label for="garantie_12_mobile" class="field-label">
                                                                    <h3 class="mt-3 text-center">
                                                                        {{ $t('devis.devis_habitation.Autres_garanties[3].label') }}
                                                                    </h3>
                                                                </label>
                                                            </div>
                                                            <div class="btn-choice sm-no-change col-sm-6">
                                                                <input type="checkbox" v-model="garanties"
                                                                    :value="Autres_garanties[5].value"
                                                                    id="garantie_13_mobile" name="Step9_mobile"
                                                                    class="field-input">
                                                                <label for="garantie_13_mobile" class="field-label">
                                                                    <h3 class="mt-3 text-center">
                                                                        {{ $t('devis.devis_habitation.Autres_garanties[5].label') }}
                                                                    </h3>
                                                                </label>
                                                            </div>
                                                            <div class="btn-choice sm-no-change col-sm-6">
                                                                <input type="checkbox" v-model="garanties"
                                                                    :value="Autres_garanties[4].value"
                                                                    id="garantie_14_mobile" name="Step9_mobile"
                                                                    class="field-input" @change="chech_scolarite()">
                                                                <label for="garantie_14_mobile" class="field-label">
                                                                    <h3 class="mt-3 text-center">
                                                                        {{ $t('devis.devis_habitation.Autres_garanties[4].label') }}
                                                                    </h3>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="wizard-card-footer clearfix">
                                            <div class="wizard-footer-left">
                                                <button @click="BacktoFourStep()" type="button" class="wizard-btn">
                                                    <span class="fas fa-arrow-left"></span>
                                                    {{ $t('devis.devis_habitation.bouton_retour') }}
                                                </button>
                                            </div>
                                            <div class="wizard-footer-right">
                                                <button @click="Stepper5Validator()" type="button" class="wizard-btn">
                                                    {{ $t('devis.devis_habitation.bouton_suivant') }}
                                                </button>
                                            </div>
                                            <!---->
                                        </div>

                                    </div>

                                    <div class="page review_page" v-show="step === 6">
                                        <div class="wizard-tab-content">
                                            <div role="tabpanel" id="Step10_mobile" aria-hidden="true"
                                                aria-labelledby="step-Step10_mobile" class="wizard-tab-container">
                                                <div>
                                                    <div class="justify-content-center row field-title"
                                                        style="color:#ffa409">
                                                        {{ $t('devis.devis_habitation.HeadLineSteper_6') }}
                                                    </div>
                                                    <div class="field-title">
                                                        {{ $t('devis.devis_habitation.subHeadlineSteper_6') }}&nbsp;:
                                                    </div>
                                                    <div class="fields" v-for="(item, index) in listHabitat" :key="index">
                                                        <div class="field-group row align-items-center">
                                                            <div class="col-lg-4"><label for="Stepper29_mobile"
                                                                    class="field-label">{{ $t('devis.devis_habitation.entetTableeauRec[0]') }}</label>
                                                            </div>
                                                            <div class="col-lg-8 field-default">
                                                                <input disabled type="text" id="Stepper29_mobile"
                                                                    name="Step10_mobile" :value="item.typeBien"
                                                                    class="field-input pac-target-input">
                                                                <div class="field-error">
                                                                    <!---->
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="field-group row align-items-center">
                                                            <div class="col-lg-4"><label for="Stepper30_mobile"
                                                                    class="field-label">{{ $t('devis.devis_habitation.entetTableeauRec[1]') }}</label>
                                                            </div>
                                                            <div class="col-lg-8 field-default">
                                                                <input disabled type="text" id="Stepper30_mobile"
                                                                    name="Step10_mobile" :value="item.nombrepiece"
                                                                    class="field-input pac-target-input">
                                                                <div class="field-error">
                                                                    <!---->
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="field-group row align-items-center">
                                                            <div class="col-lg-4"><label for="Stepper31_mobile"
                                                                    class="field-label">{{ $t('devis.devis_habitation.entetTableeauRec[2]') }}</label>
                                                            </div>
                                                            <div class="col-lg-8 field-default">
                                                                <input disabled type="tel" id="Stepper31_mobile"
                                                                    name="Step10_mobile" :value="item.nombreetage"
                                                                    class="field-input">
                                                                <div class="field-error">
                                                                    <!---->
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="field-group row align-items-center">
                                                            <div class="col-lg-4"><label for="Stepper32_mobile"
                                                                    class="field-label">{{ $t('devis.devis_habitation.entetTableeauRec[3]') }}</label>
                                                            </div>
                                                            <div class="col-lg-8 field-default">
                                                                <input disabled type="text" id="Stepper32_mobile"
                                                                    name="Step10_mobile" :value="item.naturecouverture"
                                                                    class="field-input">
                                                                <div class="field-error">
                                                                    <!---->
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="field-group row align-items-center">
                                                            <div class="col-lg-4"><label for="Stepper33_mobile"
                                                                    class="field-label">{{ $t('devis.devis_habitation.entetTableeauRec[4]') }}</label>
                                                            </div>
                                                            <div class="col-lg-8 field-default">
                                                                <input disabled type="text" id="Stepper33_mobile"
                                                                    name="Step10_mobile" :value="item.adresselogement"
                                                                    class="field-input">
                                                                <div class="field-error">
                                                                    <!---->
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="field-group row align-items-center">
                                                            <div class="col-lg-4"><label for="Stepper34_mobile"
                                                                    class="field-label">{{ $t('devis.devis_habitation.entetTableeauRec[5]') }}</label>
                                                            </div>
                                                            <div class="col-lg-8 field-default">
                                                                <input disabled type="text" id="Stepper34_mobile"
                                                                    name="Step10_mobile" :value="item.valeurcontenu"
                                                                    class="field-input">
                                                                <div class="field-error">
                                                                    <!---->
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="field-group row align-items-center">
                                                            <div class="col-lg-4"><label for="Stepper35_mobile"
                                                                    class="field-label">{{ $t('devis.devis_habitation.entetTableeauRec[6]') }}</label>
                                                            </div>
                                                            <div class="col-lg-8 field-default">
                                                                <input disabled type="text" id="Stepper35_mobile"
                                                                    name="Step10_mobile" :value="item.valeurbatiment"
                                                                    class="field-input">
                                                                <div class="field-error">
                                                                    <!---->
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="field-group row align-items-center">
                                                            <div class="col-lg-4"><label for="Stepper36_mobile"
                                                                    class="field-label">{{ $t('devis.devis_habitation.entetTableeauRec[7]') }}</label>
                                                            </div>
                                                            <div class="col-lg-8 field-default">
                                                                <input disabled type="text" id="Stepper36_mobile"
                                                                    name="Step10_mobile" :value="item.qualiteassure"
                                                                    class="field-input">
                                                                <div class="field-error">
                                                                    <!---->
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="field-group row align-items-center">
                                                            <div class="col-lg-4"><label for="Stepper37_mobile"
                                                                    class="field-label">{{ $t('devis.devis_habitation.entetTableeauRec[8]') }}</label>
                                                            </div>
                                                            <div class="col-lg-8 field-default">
                                                                <input style="margin-bottom:4px"
                                                                    v-for="(garantie, index) in item.garanties" :key="index"
                                                                    disabled type="text" id="Stepper37_mobile"
                                                                    name="Step10_mobile" :value="garantie"
                                                                    class="field-input">
                                                            </div>
                                                        </div>



                                                        <div class="field-group row align-items-center">
                                                            <div class="wizard-card-footer clearfix">
                                                                <div class="wizard-footer-right">
                                                                    <button @click="editHabitat(item)" type="button"
                                                                        class="wizard-btn">
                                                                        {{ $t('devis.devis_habitation.bouton_modifier') }}
                                                                    </button>
                                                                    <button @click="AddGaranties(item)" type="button"
                                                                        class="mt-3 wizard-btn">
                                                                        {{ $t('devis.devis_habitation.bouton_ajouter_garanties') }}
                                                                    </button>
                                                                </div>
                                                                <!---->
                                                            </div>
                                                        </div>


                                                    </div>

                                                    <div class="fields">
                                                        <div class="field-title">
                                                            {{ $t('devis.devis_habitation.choix_assureurs') }}&nbsp;:
                                                        </div>

                                                         <!-- Grid moderne pour les assureurs -->
                                                                              <div class="insurers-grid">
                                                                                <!-- Bouton "Tous" -->
                                                                                <div class="insurer-card all-insurers" :class="{ 'selected': selectAll }">
                                                                                  <input v-model="selectAll" type="checkbox" id="tous_mobile" class="insurer-input">
                                                                                  <label for="tous_mobile" class="insurer-label">
                                                                                    <div class="insurer-icon">
                                                                                      <img src="../assets/img/icones/all.png" alt="Tous les assureurs" class="insurer-logo">
                                                                                    </div>
                                                                                    <div class="insurer-info">
                                                                                      <h4 class="insurer-name">{{ $t('devis.devis_auto.bouton_tous') }}</h4>
                                                                                      <span class="insurer-badge">Tous</span>
                                                                                    </div>
                                                                                    <div class="selection-indicator">
                                                                                      <i class="fas fa-check"></i>
                                                                                    </div>
                                                                                  </label>
                                                                                </div>
                                                
                                                                                <!-- Cartes des assureurs -->
                                                                                <div 
                                                                                  class="insurer-card" 
                                                                                  v-for="assure in listeAssureurs" 
                                                                                  :key="assure._id"
                                                                                  :class="{ 'selected': assureurs.includes(assure.societe) }"
                                                                                >
                                                                                  <input 
                                                                                    v-model="assureurs" 
                                                                                    type="checkbox" 
                                                                                    :value="assure.societe" 
                                                                                    :id="assure.societe"
                                                                                    class="insurer-input"
                                                                                  >
                                                                                  <label :for="assure.societe" class="insurer-label">
                                                                                    <div class="insurer-icon">
                                                                                      <img :src="assure.logo" :alt="assure.societe" class="insurer-logo">
                                                                                    </div>
                                                                                    <div class="insurer-info">
                                                                                      <h4 class="insurer-name">{{ assure.societe }}</h4>
                                                                                      <span class="insurer-badge">Assureur</span>
                                                                                    </div>
                                                                                    <div class="selection-indicator">
                                                                                      <i class="fas fa-check"></i>
                                                                                    </div>
                                                                                  </label>
                                                                                </div>
                                                                              </div>
                                                
                                                                              <!-- Résumé de la sélection -->
                                                                              <div class="selection-summary" v-if="assureurs.length > 0">
                                                                                <div class="summary-content">
                                                                                  <i class="fas fa-info-circle"></i>
                                                                                  <span>{{ assureurs.length }} {{ $t('devis.devis_auto.assureur_label') }}{{ assureurs.length > 1 ? 's' : '' }} {{ $t('devis.devis_auto.selectionne_label') }}{{ assureurs.length > 1 ? 's' : '' }}</span>
                                                                                </div>
                                                                              </div>
                                                        <!-- <div class="field-group row field-bank">
                                                            <div class="btn-choice col-sm-6 col-6">
                                                                <input v-model="selectAll" type="checkbox" id="tous_mobile"
                                                                    class="field-input">
                                                                <label for="tous_mobile" class="field-label" label="Tous">
                                                                    <img src="../assets/img/icones/all.png"
                                                                        alt="Tous_mobile" height="60" width="60">
                                                                    <p class="field-title"
                                                                        style="margin-top:-12px;margin-bottom:-10px;color:#ffa409">
                                                                        {{ $t('devis.devis_habitation.tous_title') }}</p>
                                                                </label>
                                                            </div>
                                                            <div class="btn-choice col-sm-6 col-6"
                                                                v-for="assure in listeAssureurs" :key="assure._id">
                                                                <input v-model="assureurs" type="checkbox"
                                                                    :value="assure.societe" :id="assure.societe"
                                                                    class="field-input">
                                                                <label :for="assure.societe" class="field-label"
                                                                    :label="assure.societe">
                                                                    <img :src="assure.logo" :alt="assure.societe"
                                                                        height="50">
                                                                    <p class="field-title"
                                                                        style="margin-top:-3px;margin-bottom:-10px">
                                                                        {{ assure.societe}}</p>
                                                                </label>
                                                            </div>
                                                        </div> -->
                                                    </div>
                                                </div>
                                            </div>

                                            <div role="tabpanel" id="Step11_mobile" aria-hidden="true"
                                                aria-labelledby="step-Step11_mobile" class="wizard-tab-container">
                                                <div>
                                                    <div class="loan-group loan-group-0">
                                                        <div class="fields">
                                                            <div class="field-title">
                                                                {{ $t('devis.devis_habitation.periode') }}&nbsp;:</div>
                                                            <div class="row">
                                                                <div class="col-sm-4">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="Stepper38_mobile"
                                                                            class="field-label">{{ $t('devis.devis_habitation.duree_garantie') }}
                                                                            <button type="button" tabindex="-1" title=""
                                                                                class="field-help"
                                                                                data-original-title="Taux d'intérêt"></button></label>
                                                                        <div class="input-group rate-loan">
                                                                            <input @keypress="onlyNumber" min="1" max="12"
                                                                                type="number" id="Stepper38_mobile"
                                                                                placeholder="Durée de la garantie"
                                                                                name="Step11_mobile" class="field-input"
                                                                                v-model="duree_contrat" @keyup="dateDiff"
                                                                                disabled @change="numberMonth()">
                                                                            <div class="input-group-append">
                                                                                <div class="input-group-text">
                                                                                    {{ $t('devis.devis_habitation.mois') }}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="col-sm-4">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="Stepper39_mobile"
                                                                            class="field-label">{{ $t('devis.devis_habitation.date_effet') }}
                                                                            <button type="button" tabindex="-1" title=""
                                                                                class="field-help"
                                                                                data-original-title="Taux d'intérêt"></button></label>
                                                                        <div class="input-group rate-loan">
                                                                            <date-picker id="Stepper39_mobile"
                                                                                :disabled-date="disabledAfterToday"
                                                                                :editable="false"
                                                                                class="field-input mb-1 mt-1"
                                                                                placeholder="Cliquer ici"
                                                                                @change="dateDiff()"
                                                                                :min="new Date().toISOString().substr(0, 10)"
                                                                                v-model="dateEffet" valueType="format"
                                                                                format="YYYY-MM-DD"
                                                                                lang="fr-fr"></date-picker>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="col-sm-4">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="Stepper40_mobile"
                                                                            class="field-label">{{ $t('devis.devis_habitation.date_echeance') }}
                                                                            <button type="button" tabindex="-1" title=""
                                                                                class="field-help"
                                                                                data-original-title="Taux d'intérêt"></button></label>
                                                                        <div class="input-group rate-loan">
                                                                            <input disabled placeholder="Date d'échéance"
                                                                                v-model="dateEcheance" id="Stepper40_mobile"
                                                                                name="Step11_mobile" class="field-input">
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div role="tabpanel" id="Step12_mobile" aria-hidden="true"
                                                aria-labelledby="step-Step12_mobile" class="wizard-tab-container">
                                                <div>
                                                    <div class="loan-group loan-group-0">
                                                        <div class="fields">
                                                            <div class="field-title">
                                                                {{ $t('devis.devis_habitation.beneficiaire') }}&nbsp;:</div>
                                                            <div class="row">
                                                                <div class="col-sm-4 mt-5">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <div class="field-checkbox">
                                                                            <div class="field-label">
                                                                                {{ $t('devis.devis_habitation.idem_compte_connecte') }}
                                                                            </div>
                                                                            <div class="switch">
                                                                                <label for="Stepper41_mobile">
                                                                                    <input @change="switchBenef()"
                                                                                        v-model="switch1" type="checkbox"
                                                                                        id="Stepper41_mobile"
                                                                                        name="Step12_mobile">
                                                                                    <span class="lever"></span>
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="col-sm-6">
                                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                                        <label for="Stepper42_mobile"
                                                                            class="field-label">{{ $t('devis.devis_habitation.prenom_nom') }}
                                                                            <button type="button" tabindex="-1" title=""
                                                                                class="field-help"
                                                                                data-original-title="Taux d'intérêt"></button></label>
                                                                        <div class="input-group rate-loan">
                                                                            <input :disabled="disabledBenefInput" @click="dialogInfoBeneficiaire = true" :placeholder="$t('devis.devis_auto.nom_et_prenom')"
                                                                                v-model="proprietaire" id="Stepper42_mobile"
                                                                                name="Step12_mobile" class="field-input">
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="wizard-card-footer clearfix">
                                            <div class="wizard-footer-left">
                                                <button @click="BacktoFiveStep()" type="button" class="wizard-btn">
                                                    <span class="fas fa-arrow-left"></span>
                                                    {{ $t('devis.devis_habitation.bouton_retour') }}
                                                </button>
                                            </div>
                                            <div class="wizard-footer-right">
                                                <button :disabled="disabledButtonValidate" @click="Stepper6Validator()"
                                                    type="button" class="wizard-btn">
                                                    {{ $t('devis.devis_habitation.bouton_valider') }}
                                                </button>
                                            </div>
                                            <!---->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--    ==========================Modal for habitation list desktop ============================================ -->
        <v-dialog persistent v-model="ModalListeHabitation" max-width="1200" v-if="isDesktop()">
            <v-card tile class="border-radius policeLato">
                <v-card-text style="background:#FAFAFA">
                    <div class="wizard-tab-content">
                        <div role="tabpanel" id="UserCarTable" aria-hidden="true" aria-labelledby="step-UserCarTable"
                            class="wizard-tab-container">
                            <div>
                                <div class="loan-group loan-group-0">
                                    <div class="fields">
                                        <div class="field-title font-weight-bold">{{
                                            $t('devis.devis_habitation.logement_label') }}&nbsp;:</div>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <v-flex class="col-sm-5 offset-7">
                                                    <div class="col-sm-12">
                                                        <div class="field-group field-default mb-4 mb-sm-0">
                                                            <input v-model="searchHabitationDesktop"
                                                                :placeholder="$t('devis.devis_habitation.search_label')"
                                                                id="Stepper288" name="Step8" class="field-input">
                                                        </div>
                                                    </div>
                                                </v-flex>

                                                <v-flex style="background-color: #FAFAFA!important;z-index:10000">
                                                    <v-data-table :headers="$t('devis.devis_habitation.headerContrat')"
                                                        :items="listHabitations" :search="searchHabitationDesktop"
                                                        class="border-radius mt-2 mb-5"
                                                        style="background-color: #FAFAFA!important">
                                                        <template slot="items" slot-scope="props">
                                                            <td>{{ props.item.typeBien }}</td>
                                                            <td>{{ props.item.nombrepiece }}</td>
                                                            <td>{{ props.item.superficie }} m2</td>
                                                            <td>{{ props.item.naturecouverture }}</td>
                                                            <td>{{ props.item.adresselogement }}</td>
                                                            <td>{{ props.item.valeurcontenu }}</td>
                                                            <td>{{ props.item.valeurbatiment }}</td>
                                                            <td>
                                                                <ul class="list-boutons" style="width:150px">
                                                                    <li class="justify-content-center row">
                                                                        <v-btn small icon
                                                                            @click="getHabitationForDevis(props.item)">
                                                                            <img src="../assets/img/devis/toDevis.png"
                                                                                width="60" alt="bouton pour devis">
                                                                        </v-btn>
                                                                        <v-btn small icon
                                                                            @click="openEditHousing(props.item)"
                                                                            title="Modifier le logement">
                                                                            <span class="fa fa-edit"
                                                                                style="color: #ffa409; font-size: 18px;"></span>
                                                                        </v-btn>
                                                                        <v-btn small icon
                                                                            @click="deleteHabitation(props.item)">
                                                                            <img src="../assets/img/devis/delete.png"
                                                                                width="60" alt="supprimer logement">
                                                                        </v-btn>
                                                                    </li>
                                                                </ul>
                                                            </td>
                                                        </template>
                                                    </v-data-table>
                                                </v-flex>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="wizard-card-footer clearfix">
                        <div class="wizard-footer-left">
                            <button @click="closePopupHabitation()" type="button" class="wizard-btn">
                                <span class="fas fa-arrow-left"></span>
                                {{ $t('devis.devis_habitation.bouton_fermer') }}
                            </button>
                        </div>
                        <div class="wizard-footer-right">
                        </div>
                        <!---->
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!--    ==========================Modal for habitation list mobile ============================================ -->
        <v-dialog persistent v-model="ModalListeHabitation" v-if="isMobile()" style="width:100%!important">
            <v-card tile class="border-radius policeLato">
                <v-card-text style="background:#FAFAFA">
                    <div class="wizard-tab-content">
                        <div role="tabpanel" id="UserCarTable" aria-hidden="true" aria-labelledby="step-UserCarTable"
                            class="wizard-tab-container">
                            <div>
                                <div class="loan-group loan-group-0">
                                    <div class="fields">
                                        <div class="field-title font-weight-bold">{{
                                            $t('devis.devis_habitation.logement_label') }}&nbsp;:</div>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="col-sm-12">
                                                    <div class="field-group field-default mb-4 mb-sm-0">
                                                        <input v-model="searchHabitationDesktop"
                                                            :placeholder="$t('devis.devis_habitation.search_label')"
                                                            id="Stepper288" name="Step8" class="field-input">
                                                    </div>
                                                </div>

                                                <v-flex style="background-color: #FAFAFA!important;z-index:10000">
                                                    <v-data-table
                                                        :headers="$t('devis.devis_habitation.headerContratMobile')"
                                                        :items="listHabitations" :search="searchHabitationDesktop"
                                                        class="border-radius mt-2 mb-5"
                                                        style="background-color: #FAFAFA!important">
                                                        <template slot="items" slot-scope="props">
                                                            <td @click="getHabitationForDevis(props.item)">{{
                                                                props.item.typeBien }}</td>
                                                            <td @click="getHabitationForDevis(props.item)">{{
                                                                props.item.superficie }}</td>
                                                            <td @click="getHabitationForDevis(props.item)">{{
                                                                props.item.adresselogement }}</td>
                                                            <td>
                                                                <v-btn small icon @click="openEditHousing(props.item)"
                                                                    title="Modifier le logement">
                                                                    <span class="fa fa-edit"
                                                                        style="color: #ffa409; font-size: 18px;"></span>
                                                                </v-btn>
                                                                <v-btn small icon
                                                                    @click="deleteHabitation(props.item)">
                                                                    <img src="../assets/img/devis/delete.png" width="45"
                                                                        alt="supprimer logement">
                                                                </v-btn>
                                                            </td>
                                                        </template>
                                                    </v-data-table>
                                                </v-flex>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="wizard-card-footer clearfix">
                        <div class="wizard-footer-left">
                            <button @click="closePopupHabitation()" type="button" class="wizard-btn">
                                <span class="fas fa-arrow-left"></span>
                                {{ $t('devis.devis_habitation.bouton_fermer') }}
                            </button>
                        </div>
                        <div class="wizard-footer-right">
                        </div>
                        <!---->
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- ========= DIALOG NOMBRE ENFANT ============ -->
        <!-- ========= DIALOG NOMBRE ENFANT ============ -->
        <v-dialog v-model="modal_nombre_enfant" persistent max-width="600px">
            <v-card elevation="24" class="border-radius">
                <v-card-text style="background:#FAFAFA">
                    <div class="wizard-tab-content">
                        <div role="tabpanel" id="nombre_enfant" aria-hidden="true" aria-labelledby="step-nombre_enfant"
                            class="wizard-tab-container">
                            <div>
                                <div class="loan-group loan-group-0">
                                    <div class="fields">
                                        <div class="field-title font-weight-bold">
                                            {{ $t('devis.devis_habitation.nombre_enfant') }}</div>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="field-group field-default">
                                                    <label for="nbre_enfant" class="field-label">
                                                        {{ $t('devis.devis_habitation.nombre_enfant') }}
                                                        <!---->
                                                    </label>
                                                    <div class="input-group value-loan">
                                                        <input @keypress="onlyNumber" v-model="nombre_enfant"
                                                            :placeholder="$t('devis.devis_habitation.nombre_enfant_placeholder')"
                                                            id="nbre_enfant" name="nbre_enfant" class="field-input">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="wizard-card-footer clearfix">
                        <div class="wizard-footer-left">
                            <button @click="closeNombreEnfantValidator()" type="button" class="wizard-btn">
                                <span class="fas fa-arrow-left"></span>
                                {{ $t('devis.devis_habitation.bouton_retour') }}
                            </button>
                        </div>
                        <div class="wizard-footer-right">
                            <button @click="nombre_enfant_validator()" type="button" class="wizard-btn">
                                {{ $t('devis.devis_habitation.bouton_valider') }}
                            </button>
                        </div>
                        <!---->
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- ========= DIALOG de modifications ============ -->
        <!-- ========= DIALOG de modifications ============ -->
        <v-dialog v-model="dialogEditItem" persistent max-width="80%">
            <v-card elevation="24" class="border-radius">
                <v-card-text style="background:#FAFAFA">
                    <div class="wizard-tab-content">
                        <div role="tabpanel" id="popupEditedInfo" aria-hidden="true" aria-labelledby="step-popupEditedInfo"
                            class="wizard-tab-container">
                            <div>
                                <div class="loan-group loan-group-0">
                                    <div class="fields">
                                        <div class="field-title">{{ $t('devis.devis_habitation.popup_modif_title') }}&nbsp;:
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-4">
                                                <div class="field-group field-default">
                                                    <label for="typeBien" class="field-label">
                                                        {{ $t('devis.devis_habitation.logement_enregistre_content[0]') }}
                                                        <!---->
                                                    </label>
                                                    <div class="input-group value-loan">
                                                        <input v-model="editedItem.typeBien" id="typeBien" name="Step4"
                                                            disabled class="field-input">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="field-group field-default">
                                                    <label for="nbrePiece" class="field-label">
                                                        {{ $t('devis.devis_habitation.logement_enregistre_content[1]') }}
                                                        <!---->
                                                    </label>
                                                    <div class="input-group value-loan">
                                                        <input @keypress="onlyNumber" v-model="editedItem.nombrepiece" id="nbrePiece" name="Step4"
                                                            class="field-input">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="field-group field-default">
                                                    <label for="nbreEtage" class="field-label">
                                                        {{ $t('devis.devis_habitation.logement_enregistre_content[2]') }}
                                                        <!---->
                                                    </label>
                                                    <div class="input-group value-loan">
                                                        <input @keypress="onlyNumber" v-model="editedItem.nombreetage" id="nbreEtage" name="Step4"
                                                            class="field-input">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="fields">
                                        <div class="row">
                                            <div class="col-sm-4">
                                                <div class="field-group field-default">
                                                    <label for="Nature_couverture" class="field-label">
                                                        {{ $t('devis.devis_habitation.logement_enregistre_content[3]') }}
                                                        <!---->
                                                    </label>
                                                    <div class="input-group value-loan">
                                                        <input v-model="editedItem.naturecouverture" id="Nature_couverture"
                                                            name="Step4" disabled class="field-input">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="field-group field-default">
                                                    <label for="AdressLogement" class="field-label">
                                                        {{ $t('devis.devis_habitation.logement_enregistre_content[4]') }}
                                                        <!---->
                                                    </label>
                                                    <div class="input-group value-loan">
                                                        <input v-model="editedItem.adresselogement" id="AdressLogement"
                                                            name="Step4" class="field-input">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="field-group field-default">
                                                    <label for="valeurContenu" class="field-label">
                                                        {{ $t('devis.devis_habitation.logement_enregistre_content[5]') }}
                                                        <!---->
                                                    </label>
                                                    <div class="input-group value-loan">
                                                        <input @keypress="onlyNumber" v-model="editedItem.valeurcontenu" id="valeurContenu"
                                                            name="Step4" class="field-input">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="fields">
                                        <div class="row">
                                            <div class="col-sm-4">
                                                <div class="field-group field-default">
                                                    <label for="valeurBatiment" class="field-label">
                                                        {{ $t('devis.devis_habitation.logement_enregistre_content[6]') }}
                                                        <!---->
                                                    </label>
                                                    <div class="input-group value-loan">
                                                        <input @keypress="onlyNumber" v-model="editedItem.valeurbatiment" id="valeurBatiment"
                                                            name="Step4" class="field-input">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-4">
                                                <div class="field-group field-default">
                                                    <label for="QualiteAssure" class="field-label">
                                                        {{ $t('devis.devis_habitation.logement_enregistre_content[7]') }}
                                                        <!---->
                                                    </label>
                                                    <div class="input-group value-loan">
                                                        <input v-model="editedItem.qualiteassure" id="QualiteAssure"
                                                            name="Step4" disabled class="field-input">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="wizard-card-footer clearfix">
                        <div class="wizard-footer-left">
                            <button @click="dialogEditItem = false" type="button" class="wizard-btn">
                                <span class="fas fa-arrow-left"></span>
                                {{ $t('devis.devis_habitation.bouton_retour') }}
                            </button>
                        </div>
                        <div class="wizard-footer-right">
                            <button @click="dialogEditItem = false" type="button" class="wizard-btn">
                                {{ $t('devis.devis_habitation.bouton_valider') }}
                            </button>
                        </div>
                        <!---->
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- ========= DIALOG POUR LES INFORMATIONS DU BENEFICIAIRES AU CAS OU C 'EST PAS CELUI QUI EST CONNECTÉ ============ -->
        <!-- ========= DIALOG POUR LES INFORMATIONS DU BENEFICIAIRES AU CAS OU C 'EST PAS CELUI QUI EST CONNECTÉ ============ -->
        <v-dialog v-model="dialogInfoBeneficiaire" persistent max-width="1000">
            <v-card elevation="24" class="border-radius">
                <v-card-text style="background:#FAFAFA">
                    <div class="wizard-tab-content">
                        <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso"
                            class="wizard-tab-container">
                            <div>
                                <div class="loan-group loan-group-0">
                                    <div class="fields">
                                        <div class="field-title font-weight-bold">
                                            {{ $t('devis.devis_habitation.information_beneficiaire.information_beneficiare_title') }}
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="col-sm-12 field-radio field-radio-center">
                                                    <div class="btn-choice">
                                                        <input v-model="genre" type="radio" value="Femme" id="Homme"
                                                            name="infosPerso" class="field-input">
                                                        <label for="Homme"
                                                            class="field-label btn-choice-hide-dot">{{ $t('devis.devis_habitation.information_beneficiaire.madame') }}</label>
                                                    </div>
                                                    <div class="btn-choice">
                                                        <input v-model="genre" type="radio" value="Homme" id="Femme"
                                                            name="infosPerso" class="field-input">
                                                        <label for="Femme"
                                                            class="field-label btn-choice-hide-dot">{{ $t('devis.devis_habitation.information_beneficiaire.monsieur') }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row mt-3">
                                            <div class="col-sm-6">
                                                <div class="field-group field-default">
                                                    <label for="prenom_benef" class="field-label">
                                                        {{ $t('devis.devis_habitation.information_beneficiaire.prenom') }}*
                                                        <!---->
                                                    </label>
                                                    <div class="input-group value-loan">
                                                        <input v-model="prenom_beneficiaire"
                                                            :placeholder="$t('devis.devis_habitation.information_beneficiaire.prenom_placeholder')"
                                                            id="prenom_benef" name="infosPerso" class="field-input">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="field-group field-default mb-4 mb-sm-0">
                                                    <label for="nom_benef"
                                                        class="field-label">{{ $t('devis.devis_habitation.information_beneficiaire.nom') }}*</label>
                                                    <input v-model="nom_beneficiaire"
                                                        :placeholder="$t('devis.devis_habitation.information_beneficiaire.nom_placeholder')"
                                                        id="nom_benef" name="infosPerso" class="field-input">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row mt-3">
                                            <div class="col-sm-6">
                                                <div class="field-group field-default">
                                                    <label for="num_benef" class="field-label">
                                                        {{ $t('devis.devis_habitation.information_beneficiaire.telephone') }}
                                                        <!---->
                                                    </label>
                                                    <div class="input-group value-loan">
                                                        <input v-model="num_beneficiaire" @keypress="onlyNumber"
                                                            :placeholder="$t('devis.devis_habitation.information_beneficiaire.telephone_placeholder')"
                                                            id="num_benef" name="infosPerso" class="field-input">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="field-group field-default mb-4 mb-sm-0">
                                                    <label for="email_benf"
                                                        class="field-label">{{ $t('devis.devis_habitation.information_beneficiaire.email') }}</label>
                                                    <input v-model="email_beneficiaire"
                                                        :placeholder="$t('devis.devis_habitation.information_beneficiaire.email_placeholder')"
                                                        id="email_benf" name="infosPerso" class="field-input">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="wizard-card-footer clearfix">
                        <div class="wizard-footer-left">
                            <button @click="annulerBenef()" type="button" class="wizard-btn">
                                <span class="fas fa-arrow-left"></span>
                                {{ $t('devis.devis_habitation.bouton_annuler') }}
                            </button>
                        </div>
                        <div class="wizard-footer-right">
                            <button @click="Detail_info_beneficiaire()" type="button" class="wizard-btn">
                                {{ $t('devis.devis_habitation.bouton_ajouter') }}
                            </button>
                        </div>
                        <!---->
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>


        <!-- ========= DIALOG Add Garantie ============ -->
        <!-- ========= DIALOG Add Garantie ============ -->
        <v-dialog v-model="popupAddGaranties" persistent max-width="90%" v-if="isDesktop()">
            <v-card elevation="24" class="border-radius" v-if="HabitationToUpdate">
                <v-card-text style="background:#FAFAFA">
                    <div class="wizard-tab-content">
                        <div role="tabpanel" id="popupAddGarantie" aria-hidden="true"
                            aria-labelledby="step-popupAddGarantie" class="wizard-tab-container">
                            <div>
                                <div class="fields">
                                    <div class="field-title mb-0">
                                        {{ $t('devis.devis_habitation.bouton_autres_garanties') }}&nbsp;:
                                    </div>
                                    <div class="field-title mb-0">
                                        {{ $t('devis.devis_habitation.GarantiesBaseTitre') }}&nbsp;:
                                    </div>
                                    <div class="mt-3 field-group row field-bank">
                                        <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                            :data-tip="$t('devis.devis_habitation.Garanties[0].explications')" tabindex="1">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="GarantiesBase[0].value" id="garantie_1_to_update"
                                                name="Step9_to_update" class="field-input">
                                            <label for="garantie_1_to_update" class="field-label">
                                                <h3 class="mt-3 text-center">
                                                    <span>{{ $t('devis.devis_habitation.Garanties[0].label') }}</span>
                                                </h3>
                                            </label>
                                        </div>
                                        <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                            :data-tip="$t('devis.devis_habitation.Garanties[1].explications')" tabindex="1">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="GarantiesBase[1].value" id="garantie_2_to_update"
                                                name="Step9_to_update" class="field-input">
                                            <label for="garantie_2_to_update" class="field-label">
                                                <h3 class="mt-3 text-center">
                                                    <span>{{ $t('devis.devis_habitation.Garanties[1].label') }}</span>
                                                </h3>
                                            </label>
                                        </div>
                                        <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                            :data-tip="$t('devis.devis_habitation.Garanties[2].explications')" tabindex="1">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="GarantiesBase[2].value" id="garantie_3_to_update"
                                                name="Step9_to_update" class="field-input">
                                            <label for="garantie_3_to_update" class="field-label">
                                                <h3 class="mt-3 text-center">
                                                    <span>{{ $t('devis.devis_habitation.Garanties[2].label') }}</span>
                                                </h3>
                                            </label>
                                        </div>
                                        <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                            :data-tip="$t('devis.devis_habitation.Garanties[3].explications')" tabindex="1">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="GarantiesBase[3].value" id="garantie_4_to_update"
                                                name="Step9_to_update" class="field-input">
                                            <label for="garantie_4_to_update" class="field-label">
                                                <h3 class="mt-3 text-center">
                                                    <span>{{ $t('devis.devis_habitation.Garanties[3].label') }}</span>
                                                </h3>
                                            </label>
                                        </div>
                                        <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                            :data-tip="$t('devis.devis_habitation.Garanties[5].explications')" tabindex="1">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="GarantiesBase[5].value" id="garantie_5_to_update"
                                                name="Step9_to_update" class="field-input">
                                            <label for="garantie_5_to_update" class="field-label">
                                                <h3 class="mt-3 text-center">
                                                    <span>{{ $t('devis.devis_habitation.Garanties[5].label') }}</span>
                                                </h3>
                                            </label>
                                        </div>
                                        <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                            :data-tip="$t('devis.devis_habitation.Garanties[4].explications')" tabindex="1">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="GarantiesBase[4].value" id="garantie_6_to_update"
                                                name="Step9_to_update" class="field-input" @change="volControl()">
                                            <label for="garantie_6_to_update" class="field-label">
                                                <h3 class="mt-3 text-center">
                                                    <span>{{ $t('devis.devis_habitation.Garanties[4].label') }}</span>
                                                </h3>
                                            </label>
                                        </div>
                                        <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                            :data-tip="$t('devis.devis_habitation.Garanties[6].explications')" tabindex="1">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="GarantiesBase[6].value" id="garantie_7_to_update"
                                                name="Step9_to_update" class="field-input">
                                            <label for="garantie_7_to_update" class="field-label">
                                                <h3 class="mt-3 text-center">
                                                    <span>{{ $t('devis.devis_habitation.Garanties[6].label') }}</span>
                                                </h3>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="fields">
                                    <div class="field-title mb-0">
                                        {{ $t('devis.devis_habitation.Autres_garanties_titre') }}&nbsp;:
                                    </div>
                                    <div class="field-group row field-bank">
                                        <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                            :data-tip="$t('devis.devis_habitation.Autres_garanties[0].explications')"
                                            tabindex="1">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="Autres_garanties[0].value" id="garantie_8_to_update"
                                                name="Step9_to_update" class="field-input">
                                            <label for="garantie_8_to_update" class="field-label">
                                                <h3 class="mt-3 text-center">
                                                    <span>{{ $t('devis.devis_habitation.Autres_garanties[0].label') }}</span>
                                                </h3>
                                            </label>
                                        </div>
                                        <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                            :data-tip="$t('devis.devis_habitation.Autres_garanties[1].explications')"
                                            tabindex="1">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="Autres_garanties[1].value" id="garantie_9_to_update"
                                                name="Step9_to_update" class="field-input">
                                            <label for="garantie_9_to_update" class="field-label">
                                                <h3 class="mt-3 text-center">
                                                    <span>{{ $t('devis.devis_habitation.Autres_garanties[1].label') }}</span>
                                                </h3>
                                            </label>
                                        </div>
                                        <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                            :data-tip="$t('devis.devis_habitation.Autres_garanties[2].explications')"
                                            tabindex="1">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="Autres_garanties[2].value" id="garantie_10_to_update"
                                                name="Step9_to_update" class="field-input">
                                            <label for="garantie_10_to_update" class="field-label">
                                                <h3 class="mt-3 text-center">
                                                    <span>{{ $t('devis.devis_habitation.Autres_garanties[2].label') }}</span>
                                                </h3>
                                            </label>
                                        </div>
                                        <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                            :data-tip="$t('devis.devis_habitation.Autres_garanties[3].explications')"
                                            tabindex="1">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="Autres_garanties[3].value" id="garantie_11_to_update"
                                                name="Step9_to_update" class="field-input">
                                            <label for="garantie_11_to_update" class="field-label">
                                                <h3 class="mt-3 text-center">
                                                    <span>{{ $t('devis.devis_habitation.Autres_garanties[3].label') }}</span>
                                                </h3>
                                            </label>
                                        </div>
                                        <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                            :data-tip="$t('devis.devis_habitation.Autres_garanties[5].explications')"
                                            tabindex="1">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="Autres_garanties[5].value" id="garantie_13_to_update"
                                                name="Step9_to_update" class="field-input" @change="volControl()">
                                            <label for="garantie_13_to_update" class="field-label">
                                                <h3 class="mt-3 text-center">
                                                    <span>{{ $t('devis.devis_habitation.Autres_garanties[5].label') }}</span>
                                                </h3>
                                            </label>
                                        </div>
                                        <div class="btn-choice sm-no-change col-sm-4 col-4 tool"
                                            :data-tip="$t('devis.devis_habitation.Autres_garanties[4].explications')"
                                            tabindex="1">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="Autres_garanties[4].value" id="garantie_14_to_update"
                                                name="Step9_to_update" class="field-input" @change="chech_scolarite()">
                                            <label for="garantie_14_to_update" class="field-label">
                                                <h3 class="mt-3 text-center">
                                                    <span>{{ $t('devis.devis_habitation.Autres_garanties[4].label') }}</span>
                                                </h3>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="wizard-card-footer clearfix">
                        <div class="wizard-footer-left">
                            <button @click="loadPopup_extension_salama()" type="button" class="wizard-btn">
                                <span class="fas fa-arrow-left"></span>
                                {{ $t('devis.devis_habitation.bouton_retour') }}
                            </button>
                        </div>
                        <div class="wizard-footer-right">
                            <button @click="addGarantiesToClosePopup()" type="button" class="wizard-btn">
                                {{ $t('devis.devis_habitation.bouton_valider') }}
                            </button>
                        </div>
                        <!---->
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- ========= DIALOG Add Garantie Mobile ============ -->
        <!-- ========= DIALOG Add Garantie Mobile ============ -->
        <v-dialog persistent v-model="popupAddGaranties" max-width="90%" v-if="isMobile()">
            <v-card elevation="24" class="border-radius" v-if="HabitationToUpdate">
                <v-card-text style="background:#FAFAFA">
                    <div class="wizard-tab-content">
                        <div role="tabpanel" id="popupAddGarantie_mobile" aria-hidden="true"
                            aria-labelledby="step-popupAddGarantie_mobile" class="wizard-tab-container">
                            <div>
                                <div class="fields">
                                    <div class="field-title mb-0">
                                        {{ $t('devis.devis_habitation.bouton_autres_garanties') }}&nbsp;:
                                    </div>
                                    <div class="field-title mb-0">
                                        {{ $t('devis.devis_habitation.GarantiesBaseTitre') }}&nbsp;:
                                    </div>
                                    <div class="field-group row field-bank">
                                        <div class="btn-choice sm-no-change col-sm-6">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="GarantiesBase[0].value" id="garantie_2_mobile_to_update"
                                                name="Step9_mobile_to_update" class="field-input">
                                            <label for="garantie_2_mobile_to_update" class="field-label">
                                                <h5 class="mt-3 text-center">
                                                    {{ $t('devis.devis_habitation.Garanties[0].label') }}</h5>
                                            </label>
                                        </div>
                                        <div class="btn-choice sm-no-change col-sm-6">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="GarantiesBase[1].value" id="garantie_3_mobile_to_update"
                                                name="Step9_mobile_to_update" class="field-input">
                                            <label for="garantie_3_mobile_to_update" class="field-label">
                                                <h3 class="mt-3 text-center">
                                                    {{ $t('devis.devis_habitation.Garanties[1].label') }}</h3>
                                            </label>
                                        </div>
                                        <div class="btn-choice sm-no-change col-sm-6">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="GarantiesBase[2].value" id="garantie_4_mobile_to_update"
                                                name="Step9_mobile_to_update" class="field-input">
                                            <label for="garantie_4_mobile_to_update" class="field-label">
                                                <h3 class="mt-3 text-center">
                                                    {{ $t('devis.devis_habitation.Garanties[2].label') }}</h3>
                                            </label>
                                        </div>
                                        <div class="btn-choice sm-no-change col-sm-6">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="GarantiesBase[3].value" id="garantie_5_mobile_to_update"
                                                name="Step9_mobile_to_update" class="field-input">
                                            <label for="garantie_5_mobile_to_update" class="field-label">
                                                <h3 class="mt-3 text-center">
                                                    {{ $t('devis.devis_habitation.Garanties[3].label') }}</h3>
                                            </label>
                                        </div>
                                        <div class="btn-choice sm-no-change col-sm-6">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="GarantiesBase[5].value" id="garantie_6_mobile_to_update"
                                                name="Step9_mobile_to_update" class="field-input">
                                            <label for="garantie_6_mobile_to_update" class="field-label">
                                                <h3 class="mt-3 text-center">
                                                    {{ $t('devis.devis_habitation.Garanties[5].label') }}</h3>
                                            </label>
                                        </div>
                                        <div class="btn-choice sm-no-change col-sm-6">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="GarantiesBase[4].value" id="garantie_7_mobile_to_update"
                                                name="Step9_mobile_to_update" class="field-input">
                                            <label for="garantie_7_mobile_to_update" class="field-label">
                                                <h3 class="mt-3 text-center">
                                                    {{ $t('devis.devis_habitation.Garanties[4].label') }}</h3>
                                            </label>
                                        </div>
                                        <div class="btn-choice sm-no-change col-sm-6">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="GarantiesBase[6].value" id="garantie_8_mobile_to_update"
                                                name="Step9_mobile_to_update" class="field-input">
                                            <label for="garantie_8_mobile_to_update" class="field-label">
                                                <h3 class="mt-3 text-center">
                                                    {{ $t('devis.devis_habitation.Garanties[6].label') }}</h3>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <div class="fields">
                                    <div class="field-title mb-0">
                                        {{ $t('devis.devis_habitation.Autres_garanties_titre') }}&nbsp;:
                                    </div>
                                    <div class="field-group row field-bank">
                                        <div class="btn-choice sm-no-change col-sm-6">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="Autres_garanties[0].value" id="garantie_9_mobile_to_update"
                                                name="Step9_mobile_to_update" class="field-input">
                                            <label for="garantie_9_mobile_to_update" class="field-label">
                                                <h5 class="mt-3 text-center">
                                                    {{ $t('devis.devis_habitation.Autres_garanties[0].label') }}</h5>
                                            </label>
                                        </div>
                                        <div class="btn-choice sm-no-change col-sm-6">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="Autres_garanties[1].value" id="garantie_10_mobile_to_update"
                                                name="Step9_mobile_to_update" class="field-input">
                                            <label for="garantie_10_mobile_to_update" class="field-label">
                                                <h3 class="mt-3 text-center">
                                                    {{ $t('devis.devis_habitation.Autres_garanties[1].label') }}</h3>
                                            </label>
                                        </div>
                                        <div class="btn-choice sm-no-change col-sm-6">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="Autres_garanties[2].value" id="garantie_11_mobile_to_update"
                                                name="Step9_mobile_to_update" class="field-input">
                                            <label for="garantie_11_mobile_to_update" class="field-label">
                                                <h3 class="mt-3 text-center">
                                                    {{ $t('devis.devis_habitation.Autres_garanties[2].label') }}</h3>
                                            </label>
                                        </div>
                                        <div class="btn-choice sm-no-change col-sm-6">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="Autres_garanties[3].value" id="garantie_12_mobile_to_update"
                                                name="Step9_mobile_to_update" class="field-input">
                                            <label for="garantie_12_mobile_to_update" class="field-label">
                                                <h3 class="mt-3 text-center">
                                                    {{ $t('devis.devis_habitation.Autres_garanties[3].label') }}</h3>
                                            </label>
                                        </div>
                                        <div class="btn-choice sm-no-change col-sm-6">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="Autres_garanties[5].value" id="garantie_13_mobile_to_update"
                                                name="Step9_mobile_to_update" class="field-input">
                                            <label for="garantie_13_mobile_to_update" class="field-label">
                                                <h3 class="mt-3 text-center">
                                                    {{ $t('devis.devis_habitation.Autres_garanties[5].label') }}</h3>
                                            </label>
                                        </div>
                                        <div class="btn-choice sm-no-change col-sm-6">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="Autres_garanties[4].value" id="garantie_14_mobile_to_update"
                                                name="Step9_mobile_to_update" class="field-input"
                                                @change="chech_scolarite()">
                                            <label for="garantie_14_mobile_to_update" class="field-label">
                                                <h3 class="mt-3 text-center">
                                                    {{ $t('devis.devis_habitation.Autres_garanties[4].label') }}</h3>
                                            </label>
                                        </div>

                                        <div class="btn-choice sm-no-change col-sm-6">
                                            <input type="checkbox" v-model="HabitationToUpdate.garanties"
                                                :value="Autres_garanties[6].value" id="garantie_15_mobile_to_update"
                                                name="Step10_mobile_to_update" class="field-input">
                                            <label for="garantie_15_mobile_to_update" class="field-label">
                                                <h3 class="mt-3 text-center">{{ Autres_garanties[6].label }}</h3>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="wizard-card-footer clearfix">
                        <div class="wizard-footer-left">
                            <button @click="loadPopup_extension_salama()" type="button" class="wizard-btn">
                                <span class="fas fa-arrow-left"></span>
                                {{ $t('devis.devis_habitation.bouton_retour') }}
                            </button>
                        </div>
                        <div class="wizard-footer-right">
                            <button @click="addGarantiesToClosePopup()" type="button" class="wizard-btn">
                                {{ $t('devis.devis_habitation.bouton_valider') }}
                            </button>
                        </div>
                        <!---->
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <div v-if="dialogLoading" class="loading-state">
        <div class="loading"></div>
        <span class="ml-3 loading-text">{{ $t('devis.devis_habitation.devis_encours') }}</span>
    </div>


        <!-- <v-dialog v-model="dialogLoading" persistent width="700" v-if="isDesktop()">
            <v-card elevation="24" class="border-radius">
                <v-card-text style="background:#FFA409">
                    <div class="wizard-tab-content" style="background:#FFA409">
                        <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso"
                            class="wizard-tab-container">
                            <div>
                                <div class="loan-group loan-group-0" style="background:#FFA409">
                                    <div class="fields text-center" style="background:#FFA409">
                                        <v-progress-circular size="50" color="white" class="mr-2"
                                            indeterminate></v-progress-circular>
                                        <span class="field-title font-weight-bold"
                                            style="color:#fff">{{ $t('devis.devis_habitation.devis_encours') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogLoading" persistent width="700" v-if="isMobile()">
            <v-card elevation="24" class="border-radius">
                <v-card-text style="background:#FFA409">
                    <div class="wizard-tab-content" style="background:#FFA409">
                        <div role="tabpanel" id="infosPerso" aria-hidden="true" aria-labelledby="step-infosPerso"
                            class="wizard-tab-container">
                            <div>
                                <div class="loan-group loan-group-0" style="background:#FFA409">
                                    <div class="fields text-center" style="background:#FFA409">
                                        <span class="field-title font-weight-bold"
                                            style="color:#fff">{{ $t('devis.devis_habitation.devis_encours') }}</span>
                                    </div>
                                    <div class="fields text-center" style="background:#FFA409">
                                        <v-progress-circular size="50" color="white" class="mr-2"
                                            indeterminate></v-progress-circular>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog> -->

        <!-- ========================================= POPUP EXTENSION GARNTIE MRH SALAMA==================================================== -->
        <v-dialog v-model="popup_extension_salama" persistent max-width="600px">
            <v-card elevation="24" class="border-radius">
                <v-card-text style="background:#FAFAFA">
                    <div class="wizard-tab-content">
                        <div role="tabpanel" id="nombre_enfant" aria-hidden="true" aria-labelledby="step-nombre_enfant"
                            class="wizard-tab-container">
                            <div>
                                <div class="loan-group loan-group-0">
                                    <div class="fields">
                                        <div class="field-title font-weight-bold">Capitaux extensions (valable Salama)</div>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="row field-group field-default"
                                                    v-if="garantie_vol_efra == 'VOL PAR EFFRACTION'">
                                                    <label for="Stepper24_mobile"
                                                        class="field-label">{{ garantie_vol_efra }}</label>
                                                    <select v-model="vol_par_efraction" id="Stepper24_mobile"
                                                        name="Step8_mobile" class="field-select">
                                                        <option v-for="item in items_extension" :key="item"
                                                            :value="item.val">{{ item.text }}</option>
                                                    </select>
                                                </div>

                                                <div class="row field-group field-default"
                                                    v-if="garantie_deg_eaux == 'DEGAT DES EAUX'">
                                                    <label for="Stepper24_mobile"
                                                        class="field-label">{{ garantie_deg_eaux }}</label>
                                                    <select v-model="degat_des_eaux" id="Stepper24_mobile"
                                                        name="Step8_mobile" class="field-select">
                                                        <option v-for="item in items_extension" :key="item"
                                                            :value="item.val">{{ item.text }}</option>
                                                    </select>
                                                </div>

                                                <div class="row field-group field-default "
                                                    v-if="garantie_gdg == 'BRIS DE GLACES'">
                                                    <label for="Stepper24_mobile"
                                                        class="field-label">{{ garantie_gdg }}</label>
                                                    <select v-model="bris_de_glaces" id="Stepper24_mobile"
                                                        name="Step8_mobile" class="field-select">
                                                        <option v-for="item in items_extension_bdg" :key="item"
                                                            :value="item.val">{{ item.text }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="wizard-card-footer clearfix">
                        <div class="wizard-footer-left">
                            <button @click="check_salamas_extension()" type="button" class="wizard-btn">
                                <span class="fas fa-arrow-left"></span>
                                Retour
                            </button>
                        </div>
                        <div class="wizard-footer-right">
                            <button @click="check_salamas_extension()" type="button" class="wizard-btn">
                                Valider
                            </button>
                        </div>
                        <!---->
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- ============================================================================================================================== -->


        <!-- INCLUSION DU POPUP DE LOGIN AU CAS OU LE USER VOULANT FAIRE UNE VALIDATION N'EST PAS CONNECTE -->
        <login-form :visible="showLoginForm" @close="showLoginForm = false"></login-form>

        <!-- INCLUSION DU FORMULAIRE DE MODIFICATION D'UN LOGEMENT DE "MES LOGEMENTS" -->
        <edit-housing-dialog
            :visible="editHousingDialog"
            :housing="housingToEdit"
            @close="editHousingDialog = false"
            @saved="onHousingUpdated"
        ></edit-housing-dialog>
    </div>
</template>

<script>
import dayjs from 'dayjs'
import Api from '../services/Api'
import store from '../store/store'
import LoginForm from './auth/Login'
import configHabitation from '../common/configHabitation.json'
import PushInDataLayer from '../services/TagManager'
import EditHousingDialog from './EditHousingDialog.vue'

export default {
    name: 'Habitation',
    components: {
        LoginForm,
        EditHousingDialog
    },
    data() {
        return {
            disabledBenefInput : false,
            dialogLoading: false,
            disabledButtonValidate: false,
            HabitationDetails: {},
            headerContrat: [
                {
                    text: "Type de bien",
                    sortable: false,
                    value: "typeBien"
                },
                {
                    text: "Nombre de piéces",
                    sortable: false,
                    value: "nombrepiece"
                },
                {
                    text: "Superficie",
                    sortable: false,
                    value: "superficie"
                },
                {
                    text: "Nature couverture",
                    sortable: false,
                    value: "naturecouverture"
                },
                {
                    text: "Adresse",
                    sortable: false,
                    value: "adresselogement"
                },
                {
                    text: "Valeur contenu",
                    sortable: false,
                    value: "valeurcontenu"
                },
                {
                    text: "Valeur du bâtiment",
                    sortable: false,
                    value: "valeurbatiment"
                },
                {
                    text: "Action",
                    value: "action"
                }
            ],
            headerContratMobile: [
                {
                    text: "Type de bien",
                    sortable: false,
                    value: "typeBien"
                },
                {
                    text: "Superficie",
                    sortable: false,
                    value: "superficie"
                },
                {
                    text: "Adresse",
                    sortable: false,
                    value: "adresselogement"
                },
                {
                    text: "Action",
                    sortable: false,
                    value: "action"
                }
            ],
            searchHabitationDesktop: "",
            ModalListeHabitation: false,
            listHabitations: [],
            editHousingDialog: false,
            housingToEdit: null,
            usersHabitation: [],
            disabledMyHabitation: false,
            myHabitations: null,
            nombre_enfant: null,
            modal_nombre_enfant: false,
            VolGarantie: false,
            dialogInfoBeneficiaire: false,
            switch1: false,
            selected: [],
            genre: null,
            money: {
                thousands: ' ',
                precision: false,
                masked: false
            },
            menu: false,
            menu1: false,
            e1: 0,
            i18nFrHbitation: null,
            GarantiesBase: [],
            Autres_garanties: [],
            naturelogement: '',
            dialogEditItem: false,
            popupAddGaranties: false,
            nombrepiece: '',
            nombreetage: '',
            naturecouverture: '',
            adresselogement: '',
            showLoginForm: false,
            valeurcontenu: '',
            superficie: null,
            valeurbatiment: null,
            qualiteassure: '',
            proprietaire: '',
            prenom_beneficiaire: '',
            nom_beneficiaire: '',
            num_beneficiaire: '',
            itemsGenre: ['Homme', 'Femme'],
            email_beneficiaire: '',
            Nombre: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
            dateEcheance: '',
            dateEffet: new Date().toISOString().substr(0, 10),
            notifMessage: '',
            montantLoyer: null,
            listeAssureurs: [],
            HabitationToUpdate: null,
            assureurs: [],
            liste_type_secu: [],
            tableau_info_beneficiaire: [],
            listHabitat: [],
            garanties: ['RESPONSABILITE CIVILE'],
            isVol: false,
            TyeSecuVol: [],
            items_toiture: ['Béton', 'Tuile (ardoise)', 'Tôle metal', 'Paille'],
            autredommage: [],
            items_environ_immediat: ['Quartier résidentiel', 'Chantiers à proximité', 'Proche Usine/Marche/Station Essence'],
            duree: ['01 mois',
                '02 mois',
                '03 mois',
                '04 mois',
                '05 mois',
                '06 mois',
                '07 mois',
                '08 mois',
                '09 mois',
                '10 mois',
                '11 mois',
                '12 mois'
            ],
            editedIndex: -1,
            editedItem: {
                typeBien: null,
                nombrepiece: null,
                nombreetage: null,
                naturecouverture: null,
                adresselogement: null,
                valeurcontenuArrondi: null,
                valeurcontenu: null,
                valeurbatiment: null,
                qualiteassure: null,
            },
            duree_contrat: 12,
            environnement_immediat: null,
            step: 0,
            ToastTabSucess: {
                theme: 'toasted-primary',
                position: 'top-center',
                duration: 4000,
                fitToScreen: true,
                type: 'success',
                className: 'custom-success-class'
            }, // Customized options for success toast
            ToastTabError: {
                theme: 'toasted-primary',
                position: 'top-center',
                duration: 4000,
                fitToScreen: true,
                type: 'error'
            }, // Customized options for error toast
            valeur: null,
            popup_extension_salama: false,
            vol_par_efraction: null,
            degat_des_eaux: null,
            bris_de_glaces: null,
            current_garantie: '',
            garantie_vol_efra: null,
            garantie_deg_eaux: null,
            garantie_gdg: null,
            items_extension: [
                { text: "Jusqu' à 500 000", val: 500000 },
                { text: "Jusqu' à 1 000 000", val: 1000000 },
                { text: "Jusqu' à 2 000 000", val: 2000000 },
                { text: "Jusqu' à 5 000 000", val: 5000000 }
            ],
            items_extension_bdg: [
                { text: "Jusqu' à 250 000", val: 250000 },
                { text: "Jusqu' à 500 000", val: 500000 },
                { text: "Jusqu' à 1 000 000", val: 1000000 },
                { text: "Jusqu' à 2 000 000", val: 2000000 }
            ]
        }

    },
    watch: {

        assureurs(val) {
            let cpt = 0
            for (let v of this.assureurs) {
                if (v == 'SALAMA') {
                    for (let g of this.listHabitat[0].garanties) {
                        if (g == 'VOL PAR EFFRACTION' && this.vol_par_efraction == null) {
                            this.garantie_vol_efra = g
                            cpt = cpt + 1
                        }

                        if (g == 'DEGAT DES EAUX' && this.degat_des_eaux == null) {
                            this.garantie_deg_eaux = g
                            cpt = cpt + 1
                        }

                        if (g == 'BRIS DE GLACES' && this.bris_de_glaces == null) {
                            this.garantie_gdg = g
                            cpt = cpt + 1

                        }
                    }
                }

            }
            if (cpt >= 1) {
                this.popup_extension_salama = true
            }
        },

        notifMessage() {
            this.$toasted.show(this.notifMessage, this.ToastTabSucess)
        },

        dialog(val) {
            val || this.close()
        },

        model(val) {
            if (typeof val == 'object') {
                this.model = val.Type
            } else if (typeof val == 'string') {
                this.model = val
            }
        },

        showLoginForm(val) {
            if (val == false) {
                if (store.state.isUserLoggedIn) {
                    this.proprietaire = this.$store.state.user.prenom + ' ' + this.$store.state.user.nom
                }
            }
        }
    },

    mounted() {
        window.scrollTo(0, 0);
        this.checkToken()
        // if (store.state.isUserLoggedIn && store.state.user.code_partenaire == 'ASS381') {
        //     this.getUserHabitation()
        // } else {
        //     console.log("the user isn't connected")
        // }
        if (store.state.isUserLoggedIn && store.state.user.code_partenaire == process.env.VUE_APP_CODEP) {
            this.getUserHabitation()
        } else {
            console.log("the user isn't connected")
        }
        this.getListePartenaire()
    },

    created() {
        this.i18nFrHbitation = configHabitation.French;
        this.GarantiesBase = configHabitation.French.Garanties;
        this.TyeSecuVol = configHabitation.French.Type_securite_vol;
        this.Autres_garanties = configHabitation.French.Autres_garanties
    },

    methods: {
        checkToken() {
            Api().get('user/check/token')
                .then((resultat) => {
                    // verifie si le token exist
                    if (!resultat.data.ok) {
                        store.state.isUserLoggedIn = false;
                        store.dispatch("setUser", {});
                        store.dispatch("setToken", {});
                        this.showLoginForm = true
                    }
                }).catch((err) => {
                    // verifie  si le token est expiré
                    if (err.response.data.ok === false) {
                        store.state.isUserLoggedIn = false;
                        store.dispatch("setUser", {});
                        store.dispatch("setToken", {});
                        this.showLoginForm = true
                    }
                });
        },
        addGarantiesToClosePopup() {
            if (this.HabitationToUpdate.garanties.length >= 1) {
                this.popupAddGaranties = false
            } else {
                this.$toasted.show('Veuillez cocher une garantie au minimum ! ', this.ToastTabError)
            }
        },
        check_salamas_extension() {
            let table_ = this.listHabitat[0].garanties
            for (let i = table_.length - 1; i >= 0; i--) {
                if (table_[i] == 'VOL PAR EFFRACTION' && this.vol_par_efraction == null) {
                    table_.splice(i, 1)
                }

                if (table_[i] == 'DEGAT DES EAUX' && this.degat_des_eaux == null) {
                    table_.splice(i, 1)
                }

                if (table_[i] == 'BRIS DE GLACES' && this.bris_de_glaces == null) {
                    table_.splice(i, 1)
                }
            }
            this.popup_extension_salama = false
        },

        loadPopup_extension_salama() {
            let cpt = 0
            for (let v of this.assureurs) {
                if (v == 'SALAMA') {
                    for (let g of this.listHabitat[0].garanties) {
                        if (g == 'VOL PAR EFFRACTION' && this.vol_par_efraction == null) {
                            this.garantie_vol_efra = g
                            cpt = cpt + 1
                        }

                        if (g == 'DEGAT DES EAUX' && this.degat_des_eaux == null) {
                            this.garantie_deg_eaux = g
                            cpt = cpt + 1
                        }

                        if (g == 'BRIS DE GLACES' && this.bris_de_glaces == null) {
                            this.garantie_gdg = g
                            cpt = cpt + 1

                        }
                    }
                }

            }
            if (cpt >= 1) {
                this.popup_extension_salama = true
            }
            this.popupAddGaranties = false
        },

        deleteHabitation(item) {
            const UserHabitation = {
                habitationid: item._id
            }

            Api().post("habitation/delete", UserHabitation)
                .then(response => {
                    if (response.status == 200) {
                        this.getUserHabitation()
                        this.$toasted.show("Logement supprimé avec succès !", this.ToastTabSucess)

                    }
                })
                .catch(err => { })

        },

        ListHabitationCreate() {
            const Habitat = {
                typeBien: this.HabitationDetails.typeBien,
                nombrepiece: this.HabitationDetails.nombrepiece,
                nombreetage: this.HabitationDetails.nombreetage,
                naturecouverture: this.HabitationDetails.naturecouverture,
                adresselogement: this.HabitationDetails.adresselogement,
                valeurcontenu: this.HabitationDetails.valeurcontenu,
                valeurbatiment: this.HabitationDetails.valeurbatiment,
                qualiteassure: this.HabitationDetails.qualiteassure,
                montaLoyer: this.HabitationDetails.montantLoyer,
                assureurs: this.listeAssureurs,
                garanties: this.garanties,
                branche: 'Habitation',
                dateEffet: this.dateEffet,
                dateEcheance: this.dateEcheance,
                ext_vol_par_efraction: this.vol_par_efraction,
                ext_degat_des_eaux: this.degat_des_eaux,
                ext_bris_de_glaces: this.bris_de_glaces,
                dateSouscription: dayjs(new Date()).format('YYYY-MM-DD')
            };
            this.listHabitat = []
            this.listHabitat.push(Habitat);
        },

        saveUserHabitation() {
            if (this.myHabitations == 'mes_habitations') {
                console.log("Déja enregistré !")
            } else {
                const UserHabitation = {
                    userid: store.state.user._id,
                    typeBien: this.naturelogement,
                    nombrepiece: this.nombrepiece,
                    nombreetage: this.nombreetage,
                    superficie: this.nombreetage,
                    naturecouverture: this.naturecouverture,
                    adresselogement: this.adresselogement,
                    environnement_immediat: this.environnement_immediat,
                    valeurcontenu: this.RoundToMillion(this.valeurcontenu),
                    valeurbatiment: this.valeurbatiment ? Number(this.valeurbatiment.replace(/[^0-9.-]+/g, "")) : 0,
                    qualiteassure: this.qualiteassure,
                    montaLoyer: this.montantLoyer ? Number(this.montantLoyer.replace(/[^0-9.-]+/g, "")) : 0,
                }
                Api().post("habitation/save", UserHabitation)
                    .then(response => {
                        this.$toasted.show("Habitation enregistré avec succés !", this.ToastTabSucess)
                    })
                    .catch(error => {
                        const message = (error.response && error.response.data && error.response.data.msg) || "Erreur lors de l'enregistrement du logement dans Mes logements."
                        this.$toasted.show(message, this.ToastTabError)
                    });
            }
        },

        closePopupHabitation() {
            this.ModalListeHabitation = false
            this.myHabitations = null
        },

        getHabitationForDevis(item) {
            this.HabitationDetails = item
            this.step = 5
            this.ModalListeHabitation = false
            document.getElementById("firstStep").classList.add('checked');
            document.getElementById("testup").classList.add('widthFive');
        },

        myHabitationValidator() {
            if (!store.state.isUserLoggedIn) {
                if (this.myHabitations == 'nouveau') {
                    this.step = 1
                }
            } else {
                if (this.myHabitations == 'nouveau') {
                    this.step = 1
                }
            }
        },

        getListHabitation() {
            if (!store.state.isUserLoggedIn) {
                this.$toasted.show('Identifiez-vous pour une meilleure expérience !', this.ToastTabError)
                this.showLoginForm = true
            } else {
                this.ModalListeHabitation = true
                this.myHabitations = 'mes_habitations'
            }
            this.getUserHabitation()
        },

        getUserHabitation() {
            Api().post("habitation/myhouse", { userid: store.state.user._id })
                .then(response => {
                    this.listHabitations = response.data.logements
                });
        },

        openEditHousing(item) {
            this.housingToEdit = item
            this.editHousingDialog = true
        },

        onHousingUpdated() {
            this.getUserHabitation()
        },

        disabledBeforeToday(date) {
            const today = new Date();
            return date > today;
        },
        disabledAfterToday(date) {
            const today = dayjs(new Date()).add(-1, 'day')
            return date < today;
        },
        yearsDiffDateEffet() {
            const date1 = dayjs(this.dateEffet);
            const date2 = dayjs(new Date().toISOString().substr(0, 10));
            let daydiff = date2.diff(date1, 'days');

            this.ageArrivee = daydiff;

            if (this.ageArrivee > 0) {
                this.ageArrivee = null;
                this.annee_mois = '';
                this.$toasted.show('Erreur, date postérieure à la date actuelle! ', this.ToastTabError)
                this.dateEffet = null

            }

        },
        passFirstStep() {
            document.getElementById("sixStep").classList.add('checked');
            document.getElementById("testup").classList.add('widthSix');
        },
        BackTolistHabitation() {
            this.step = 0
            this.myHabitations = null
        },

        BacktoFirstStep() {
            this.step = 1
            document.getElementById("firstStep").classList.remove('checked');
            document.getElementById("testup").classList.remove('widthSecond');

        },

        BacktoSecondStep() {
            this.step = 2
            document.getElementById("firstStep").classList.remove('checked');
            document.getElementById("testup").classList.remove('widthThirt');

        },
        BacktoThirstStep() {
            this.step = 3
            document.getElementById("firstStep").classList.remove('checked');
            document.getElementById("testup").classList.remove('widthFour');

        },
        BacktoFourStep() {
            if (this.myHabitations == 'mes_habitations') {
                this.step = 0
                this.myHabitations = null
                document.getElementById("firstStep").classList.remove('checked');
                document.getElementById("secondStep").classList.remove('checked');
                document.getElementById("testup").classList.remove('widthFive');
            } else {
                this.step = 4
                document.getElementById("secondStep").classList.remove('checked');
                document.getElementById("testup").classList.remove('widthFive');
            }
        },
        BacktoFiveStep() {
            this.step = 5
            document.getElementById("secondStep").classList.remove('checked');
            document.getElementById("testup").classList.remove('widthSix');

        },
        prev() {
            this.step--;
        },
        next() {
            this.step++;
        },

        RoundToMillion(num) {
            const parts = num.split(" ");
            const fac = Math.pow(1000, parts.length - 1);
            return (Math.ceil(parseInt(parts.join("")) / fac) * fac)
        },

        volControl() {
            let trouver = 0;
            for (let index = 0; index < this.garanties.length; index++) {
                if (this.garanties[index] == 'VOL') {
                    trouver = 1
                }
            }
            if (trouver == 1 && !this.isVol) {
                this.isVol = true
            } else {
                this.garanties.pop();
                this.isVol = false
            }
        },

        chech_scolarite() {
            if (!this.HabitationToUpdate) {
                let trouver = 0;
                for (let index = 0; index < this.garanties.length; index++) {
                    if (this.garanties[index] == 'ASSURANCE SCOLARITE') {
                        trouver = 1
                    }
                }
                if (trouver == 1) {
                    this.modal_nombre_enfant = true
                } else {
                    this.garanties.pop();
                    this.modal_nombre_enfant = false
                }
            } else {
                let trouver = 0;
                for (let index = 0; index < this.HabitationToUpdate.garanties.length; index++) {
                    if (this.HabitationToUpdate.garanties[index] == 'ASSURANCE SCOLARITE') {
                        trouver = 1
                    }
                }
                if (trouver == 1) {
                    this.modal_nombre_enfant = true
                } else {
                    this.HabitationToUpdate.garanties.pop();
                    this.modal_nombre_enfant = false
                }
            }
        },

         closeNombreEnfantValidator() {
            let trouver = 0;
            for (let index = 0; index < this.garanties.length; index++) {
                if (this.garanties[index] == 'ASSURANCE SCOLARITE') {
                    trouver = 1
                }
            }

            if (trouver == 1 && !this.nombre_enfant || this.nombre_enfant <= 0) {
                this.garanties.pop();
                this.modal_nombre_enfant = false
            } else {
                this.$toasted.show('Veuiller valider le nombre d\'enfant saisi ! ', this.ToastTabError)
                //this.modal_nombre_enfant = false
            }
        },

        nombre_enfant_validator() {
            let trouver = 0;
            for (let index = 0; index < this.garanties.length; index++) {
                if (this.garanties[index] == 'ASSURANCE SCOLARITE') {
                    trouver = 1
                }
            }

            if (trouver == 1 && !this.nombre_enfant || this.nombre_enfant <= 0) {
                this.$toasted.show('Veuiller saisir le nombre d\'enfant ! ', this.ToastTabError)
                // this.garanties.pop();
                // this.modal_nombre_enfant = false
            } else {
                this.modal_nombre_enfant = false
            }
        },

        /*============= fonction du switch pour l'affichage du champ beneficiaire ===========*/
        switchBenef() {
            if (!this.$store.state.isUserLoggedIn) {
                this.showLoginForm = true
            } else if (this.switch1) {
                if (!this.$store.state.isUserLoggedIn) {
                    this.showLoginForm = true;
                    this.switch1 = false;
                    this.proprietaire = ''
                } else {
                    this.disabledBenefInput = true
                    this.proprietaire = this.$store.state.user.prenom + ' ' + this.$store.state.user.nom
                }
            } else {
                this.proprietaire = '';
                this.disabledBenefInput = false
                //this.dialogInfoBeneficiaire = true
            }
        },

        /*============= Action sur le button annuler du popup beneficiaire ===========*/
        annulerBenef() {
            this.dialogInfoBeneficiaire = false;
            //this.switch1 = true;
            //this.proprietaire = this.$store.state.user.prenom + ' ' + this.$store.state.user.nom
        },

        /*============= Action sur le button valider infos du popup beneficiaire ===========*/
        Detail_info_beneficiaire() {
            if (this.prenom_beneficiaire && this.nom_beneficiaire) {
                //if (this.num_beneficiaire && this.email_beneficiaire) {
                    let Beneficiaire = {
                        prenom: this.prenom_beneficiaire,
                        numero: this.num_beneficiaire,
                        nom: this.nom_beneficiaire,
                        email: this.email_beneficiaire,
                        genre: this.genre
                    };

                    this.tableau_info_beneficiaire.push(Beneficiaire);
                    this.proprietaire = this.prenom_beneficiaire + ' ' + this.nom_beneficiaire;
                    this.dialogInfoBeneficiaire = false;

                // } else {
                //     this.$toasted.show('Tous les (*) sont obligatoires ! ', this.ToastTabError)
                // }
            } else {
                this.$toasted.show('Tous les (*) sont obligatoires ! ', this.ToastTabError)
            }
        },

        /*=============Filtre sans le + ni lettre sur les champs de type number ===========*/
        onlyNumber($event) {
            let NumOnly = ($event.NumOnly ? $event.NumOnly : $event.which);
            if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
                $event.preventDefault();
            }
        },

        isMobile: function () {
            if (screen.width <= 760) {
                return true;
            } else {
                return false;
            }
        },

        isDesktop: function () {
            if (screen.width > 760) {
                return true;
            } else {
                return false;
            }
        },

        getListePartenaire: function () {
            Api().get('partenaire/partners/habitation')
                .then(response => {
                    this.listeAssureurs = response.data.partenaires
                })

                .catch(err => {
                    err
                })
        },

        // next: function () {
        //     const active = parseInt(this.active);
        //     this.active = (active < 2 ? active + 1 : 0)
        // },

        dateDiff: function () {
            if (this.dateEffet === '' && this.duree_contrat === '') this.dateEcheance = '';
            let inter = dayjs(this.dateEffet).add(this.duree_contrat, 'month').format('YYYY-MM-DD');
            this.dateEcheance = dayjs(inter).add(-1, 'day').format('YYYY-MM-DD')
            this.yearsDiffDateEffet()
        },
        ClearForm: function () {
            this.naturecouverture = '';
            this.nombrepiece = '';
            this.nombreetage = '';
            this.nombreniveau = '';
            this.naturecouverture = '';
            this.adresselogement = '';
            this.valeurcontenu = '';
            this.valeurbatiment = '';
            this.garanties = ['RESPONSABILITE CIVILE'];
            this.qualiteassure = '';
        },

        AddGaranties(item) {
            this.HabitationToUpdate = item;
            this.popupAddGaranties = true
        },
        /*========Stepper 1 fields validator===========*/
        Stepper1Validator() {
            if (this.naturelogement) {
                if (this.nombrepiece) {
                    if (this.nombreetage && this.nombreetage >= 4) {
                        document.getElementById("testup").classList.add('widthFirst');
                        this.next()
                    } else {
                        this.$toasted.show("Veuiller saisir la surface développée supérieure ou égale à 4 m2 au minimum", this.ToastTabError)
                    }
                } else {
                    this.$toasted.show('Veuiller saisir le nombre de pièce', this.ToastTabError)
                }
            } else {
                this.$toasted.show('Nature du logement obligatoire', this.ToastTabError)
            }
        },

        /*========Stepper 2 fields validator===========*/
        Stepper2Validator() {
            if (this.naturecouverture) {
                if (this.environnement_immediat) {
                    if (this.adresselogement) {
                        this.next()
                        document.getElementById("testup").classList.add('widthSecond');
                    } else {
                        this.$toasted.show("Veuiller saisir l'adresse du logement!", this.ToastTabError)
                    }
                } else {
                    this.$toasted.show('Environnement immédiat obligatoire !', this.ToastTabError)
                }
            } else {
                this.$toasted.show('Type de toiture du logement obligatoire', this.ToastTabError)
            }
        },

        calculeValeurBatiment() {
            let VB = this.montantLoyer && Number(this.montantLoyer.replace(/[^0-9.-]+/g, ""))
            let fac = 180
            let Total = VB * fac
            this.valeurbatiment = Total.toLocaleString()
        },

        /*========Stepper 3 fields validator===========*/
        Stepper3Validator() {
            if (this.qualiteassure) {
                if (this.qualiteassure == 'locataire') {

                    if (this.montantLoyer && Number(this.montantLoyer.replace(/[^0-9.-]+/g, "")) >= 50000) {
                        this.calculeValeurBatiment()
                        document.getElementById("testup").classList.add('widthThirt');
                        this.next()
                    } else {
                        this.$toasted.show('Le montant du loyer doit être au minimum 50 000 FCFA!!', this.ToastTabError)
                    }
                } else {
                    this.next()
                    document.getElementById("testup").classList.add('widthThirt');
                }

            } else {
                this.$toasted.show("Qualité de l'assuré obligatoire !", this.ToastTabError)
            }

        },

        /*========Stepper 4 fields validator===========*/
        Stepper4Validator() {
            if (this.valeurcontenu && Number(this.valeurcontenu.replace(/[^0-9.-]+/g, "")) >= 2000000) {
                if (this.valeurbatiment && Number(this.valeurbatiment.replace(/[^0-9.-]+/g, "")) >= 2000000) {
                    if (this.valeurbatiment && Number(this.valeurbatiment.replace(/[^0-9.-]+/g, "")) >= 500000000) {
                        this.$toasted.show('Valeur bâtiment limitée à 500 Millions FCFA. Nous consulter si besoin!', this.ToastTabError)
                    } else {
                        this.next()
                        document.getElementById("firstStep").classList.add('checked');
                        document.getElementById("testup").classList.add('widthFour');
                    }
                } else {
                    this.$toasted.show('Valeur du bâtiment obligatoire et doit être supérieure ou égale a 2 000 000!', this.ToastTabError)
                }
            } else {
                this.$toasted.show('Valeur du contenu obligatoire et doit être supérieure ou égale a 2 000 000!', this.ToastTabError)
            }
        },

        /*========Stepper 5 fields validator===========*/
        Stepper5Validator() {
            if (!this.$store.state.isUserLoggedIn) {
                this.switch1 = false
            }

            if (this.garanties.length > 0) {
                if (this.myHabitations == 'mes_habitations') {
                    this.listHabitat = [];
                    const Habitat = {
                        typeBien: this.HabitationDetails.typeBien,
                        nombrepiece: this.HabitationDetails.nombrepiece,
                        nombreetage: this.HabitationDetails.nombreetage,
                        naturecouverture: this.HabitationDetails.naturecouverture,
                        adresselogement: this.HabitationDetails.adresselogement,
                        valeurcontenu: this.HabitationDetails.valeurcontenu,
                        valeurbatiment: this.HabitationDetails.valeurbatiment,
                        qualiteassure: this.HabitationDetails.qualiteassure,
                        montaLoyer: this.HabitationDetails.montaLoyer,
                        assureurs: this.listeAssureurs,
                        garanties: this.garanties,
                        branche: 'Habitation',
                        dateEffet: this.dateEffet,
                        dateEcheance: this.dateEcheance,
                        dateSouscription: dayjs(new Date()).format('YYYY-MM-DD')
                    };
                    this.listHabitat.push(Habitat);
                    this.next()
                    document.getElementById("secondStep").classList.add('checked');
                    document.getElementById("testup").classList.add('widthFive');
                    this.dateDiff()
                } else {
                    this.listHabitat = [];
                    const Habitat = {
                        typeBien: this.naturelogement,
                        nombrepiece: this.nombrepiece,
                        nombreetage: this.nombreetage,
                        naturecouverture: this.naturecouverture,
                        adresselogement: this.adresselogement,
                        valeurcontenu: this.valeurcontenu,
                        valeurbatiment: this.valeurbatiment,
                        qualiteassure: this.qualiteassure,
                        montaLoyer: this.montantLoyer,
                        assureurs: this.listeAssureurs,
                        garanties: this.garanties,
                        branche: 'Habitation',
                        dateEffet: this.dateEffet,
                        dateEcheance: this.dateEcheance,
                        dateSouscription: dayjs(new Date()).format('YYYY-MM-DD')
                    };
                    this.listHabitat.push(Habitat);
                    this.next()
                    document.getElementById("secondStep").classList.add('checked');
                    document.getElementById("testup").classList.add('widthFive');
                    this.dateDiff()
                }
            } else {
                this.$toasted.show('Choisissez au moins une garantie !', this.ToastTabError)
            }
            //this.proprietaire = this.$store.state.user.prenom + ' ' + this.$store.state.user.nom;
            this.dateDiff()
        },

        editHabitat(item) {
            this.editedIndex = this.listHabitat.indexOf(item);
            this.editedItem = item;
            this.dialogEditItem = true
        },

        close() {
            this.dialogEditItem = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1
            }, 300)
        },

        numberMonth() {
            if (this.duree_contrat == 12) {
                this.dateDiff()
                return true
            } else {
                return false
            }
        },

        /*=================Verification de la session de l'utilisateur et envoie des donnees==============*/
        Stepper6Validator() {
            if (!store.state.isUserLoggedIn) {
                const val = {
                    position: 'quote-creation',
                    event: 'login_intent'
                }
                this.$loginPopupPosition.position = 'quote-creation'
                PushInDataLayer(val)
                this.showLoginForm = true
            } else if (store.state.isUserLoggedIn && this.proprietaire) {
                if (this.dateEffet && this.duree_contrat && this.dateEcheance) {
                    if (this.assureurs.length > 0) {

                        document.getElementById("thirstStep").classList.add('checked');
                        document.getElementById("testup").classList.add('widthSix');

                        if (this.myHabitations == 'mes_habitations') {
                            const Habitat = {
                                userid: store.state.user._id,
                                createur: store.state.user._id,
                                typeBien: this.HabitationDetails.typeBien,
                                nombrepiece: this.HabitationDetails.nombrepiece,
                                nombreetage: this.HabitationDetails.nombreetage,
                                superficie: this.HabitationDetails.nombreetage,
                                naturecouverture: this.HabitationDetails.naturecouverture,
                                adresselogement: this.HabitationDetails.adresselogement,
                                proprietaire: {
                                    prenom: '',
                                    nom: ''
                                },
                                environnement_immediat: this.HabitationDetails.environnement_immediat,
                                valeurcontenu: this.HabitationDetails.valeurcontenu,
                                valeurbatiment: this.HabitationDetails.valeurbatiment,
                                qualiteassure: this.HabitationDetails.qualiteassure,
                                montaLoyer: this.HabitationDetails.montaLoyer,
                                assureurs: this.assureurs,
                                garanties: this.garanties,
                                nombre_enfant: this.nombre_enfant,
                                branche: 'Habitation',
                                dateEffet: this.dateEffet,
                                dateEcheance: this.dateEcheance,
                                ext_vol_par_efraction: Number(this.vol_par_efraction),
                                ext_degat_des_eaux: Number(this.degat_des_eaux),
                                ext_bris_de_glaces: Number(this.bris_de_glaces),
                                plateforme: "Front",
                                dateSouscription: dayjs(new Date()).format('YYYY-MM-DD')
                            };
                            if (this.switch1) {
                                Habitat.proprietaire.prenom = this.$store.state.user.prenom;
                                Habitat.proprietaire.nom = this.$store.state.user.nom
                            } else {
                                Habitat.proprietaire = this.tableau_info_beneficiaire[0]
                            }
                            if (this.numberMonth() == true) {
                                this.ClearForm();
                                this.disabledButtonValidate = true
                                this.dialogLoading = true;

                                Api().post('devis/add', Habitat)
                                    .then(result => {
                                        let GtmVal = {
                                            branche: 'habitation',
                                            entry_point: localStorage.getItem('quoteCreationEntryPoint'),
                                            insurer_number: this.assureurs.length,
                                            event: 'quote_creation'
                                        }
                                        PushInDataLayer(GtmVal)

                                        if (result.data.message) {
                                            this.notif = true;
                                            this.notifMessage = result.data.message;
                                            this.$store.dispatch('setDevis', result.data);
                                            this.dialogLoading = false, this.disabledButtonValidate = false, this.$router.push({
                                                name: 'listDevis'
                                            })
                                        }
                                    }).catch(error=>{
                                        this.$toasted.show(error.response.data.message, this.ToastTabError)
                                        this.dialogLoading = false
                                        this.disabledButtonValidate = false
                                    })
                            } else {
                                this.$toasted.show("Le nombre de mois doit être 12 pour devis habitation!", this.ToastTabError);
                                this.duree = '';
                            }
                        }
                        else {
                            this.saveUserHabitation()
                            const Habitat = {
                                userid: store.state.user._id,
                                createur: store.state.user._id,
                                typeBien: this.naturelogement,
                                nombrepiece: this.nombrepiece,
                                nombreetage: this.nombreetage,
                                superficie: this.nombreetage,
                                naturecouverture: this.naturecouverture,
                                adresselogement: this.adresselogement,
                                proprietaire: {
                                    prenom: '',
                                    nom: ''
                                },
                                environnement_immediat: this.environnement_immediat,
                                valeurcontenu: this.RoundToMillion(this.valeurcontenu),
                                valeurbatiment: Number(this.valeurbatiment.replace(/[^0-9.-]+/g, "")),
                                qualiteassure: this.qualiteassure,
                                montaLoyer: Number(this.montantLoyer.replace(/[^0-9.-]+/g, "")),
                                assureurs: this.assureurs,
                                garanties: this.garanties,
                                nombre_enfant: this.nombre_enfant,
                                branche: 'Habitation',
                                dateEffet: this.dateEffet,
                                dateEcheance: this.dateEcheance,
                                ext_vol_par_efraction: this.vol_par_efraction,
                                ext_degat_des_eaux: this.degat_des_eaux,
                                ext_bris_de_glaces: this.bris_de_glaces,
                                plateforme: "Front",
                                dateSouscription: dayjs(new Date()).format('YYYY-MM-DD')
                            };
                            if (this.switch1) {
                                Habitat.proprietaire.prenom = this.$store.state.user.prenom;
                                Habitat.proprietaire.nom = this.$store.state.user.nom
                            } else {
                                Habitat.proprietaire = this.tableau_info_beneficiaire[0]
                            }

                            if (this.numberMonth() == true) {
                                this.ClearForm();
                                this.disabledButtonValidate = true
                                this.dialogLoading = true;

                                Api().post('devis/add', Habitat)
                                    .then(result => {
                                        let GtmVal = {
                                            branche: 'habitation',
                                            entry_point: localStorage.getItem('quoteCreationEntryPoint'),
                                            insurer_number: this.assureurs.length,
                                            event: 'quote_creation'
                                        }
                                        PushInDataLayer(GtmVal)

                                        if (result.data.message) {
                                            this.notif = true;
                                            this.notifMessage = result.data.message;
                                            this.$store.dispatch('setDevis', result.data);
                                            this.dialogLoading = false, this.disabledButtonValidate = false, this.$router.push({
                                                name: 'listDevis'
                                            })
                                           
                                        }
                                    }).catch(error=>{
                                        this.$toasted.show(error.response.data.message, this.ToastTabError)
                                        this.dialogLoading = false
                                        this.disabledButtonValidate = false
                                    })
                            } else {
                                this.$toasted.show("Le nombre de mois doit être 12 pour devis habitation!", this.ToastTabError);
                                this.duree = '';
                            }
                        }

                    } else {
                        this.$toasted.show('Choisissez au moins un assureur !', this.ToastTabError)
                    }

                } else {
                    this.$toasted.show("Durée et date d'échéance obligatoires ! ", this.ToastTabError)
                }

            } else {
                this.$toasted.show("Nom complet du bénéficiaire obligatoire !", this.ToastTabError)
            }
        },

        //test api orange money

    },
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? '' : "Modification de l'habitation"
        },

        selectAll: {
            get: function () {
                return this.listeAssureurs ? this.selected.length == this.listeAssureurs.length : false;
            },
            set: function (value) {
                const assureurs = [];

                if (value) {
                    this.listeAssureurs.forEach(function (assure) {
                        assureurs.push(assure.societe);
                    });
                }
                this.assureurs = assureurs;
            }
        }
    }
}
</script>

<style lang="less" scoped>@import "../assets/css/button.css";
@import "../assets/css/devis_css.css";

::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    font-size: 15px;
}

.form {
    background-color: #fff;
    padding: 1.5rem;
}

.form .page {
    height: auto;
}

button.next {
    position: absolute;
    bottom: 0;
    right: 0;
    margin-right: 1.5rem;
    margin-bottom: 1rem;
}

button.previous {
    position: absolute;
    bottom: 0;
    left: 0;
    margin-left: 1.5rem;
    margin-bottom: 1rem;
}


button.edit {
    position: absolute;
    bottom: 0;
    right: 0;
}

h4 {
    color: #29323a;
    margin-bottom: 15px;
    font-weight: 600;
}




html {
    background-color: #1a1a1a;
    overflow: hidden;
}

.middle {
    width: auto;
    text-align: center;
    /* Made by */
}

.middle h1 {
    font-family: "Inter", sans-serif;
    color: #fff;
}

.middle input[type="radio"] {
    display: none;
}

.middle input[type="radio"]:checked+.box {
    background-color: rgba(255, 164, 9, 0.07);
    transition: all .33s ease;
    border: 2px solid #ffa409;
    color: #29323a;
}

.middle input[type="radio"]:checked+.box span {
    color: #29323a;
    transform: translateY(70px);
}

.middle input[type="radio"]:checked+.box span:before {
    transform: translateY(0px);
    opacity: 1;
}

.middle .box {
    width: 220px;
    height: 150px;
    border-radius: 12px;
    background-color: #fff;
    transition: all 250ms ease;
    will-change: transition;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    position: relative;
    box-shadow: 0 4px 8px rgb(172 186 200 / 10%);
    font-size: 10px;
    border: 1px solid #d9dee3;
    font-family: Open Sans, sans-serif;
    font-weight: 900;
}

.middle .box:hover {
    background-color: rgba(255, 164, 9, 0.07);
    transition: all .33s ease;
    border: 2px solid #ffa409;
}

.middle .box:hover span {
    color: #29323a;
}

.middle .box:active {
    transform: translateY(10px);
}

.middle .box span {
    position: absolute;
    transform: translate(0, 60px);
    left: 0;
    right: 0;
    padding-top: 15%;
    transition: all 300ms ease;
    font-size: 1.5em;
    user-select: none;
    color: #29323a;
}

.middle .box span:before {
    font-size: 1.2em;
    font-family: FontAwesome;
    display: block;
    transform: translateY(-80px);
    opacity: 0;
    transition: all 300ms ease-in-out;
    font-weight: normal;
    color: #fff;
}

.middle p {
    color: #fff;
    font-family: "Inter", sans-serif;
    font-weight: 400;
}

.middle p a {
    text-decoration: underline;
    font-weight: bold;
    color: #fff;
}

.middle p span:after {
    content: "\f0e7";
    font-family: FontAwesome;
    color: yellow;
}

.widthFirst {
    background-color: var(--custom-color-primary) !important;
    height: 5px;
    border-radius: 5px;
    transition: width .33s ease;
    width: 8.55556%;
}

.widthSecond {
    background-color: var(--custom-color-primary) !important;
    height: 5px;
    border-radius: 5px;
    transition: width .33s ease;
    width: 16.11112%;
}

.widthThirt {
    background-color: var(--custom-color-primary) !important;
    height: 5px;
    border-radius: 5px;
    transition: width .33s ease;
    width: 24.11112%;
}

.widthFour {
    background-color: var(--custom-color-primary) !important;
    height: 5px;
    border-radius: 5px;
    transition: width .33s ease;
    width: 33.11112%;
}

.widthFive {
    background-color: var(--custom-color-primary) !important;
    height: 5px;
    border-radius: 5px;
    transition: width .33s ease;
    width: 65%;
}

.widthSix {
    background-color: var(--custom-color-primary) !important;
    height: 5px;
    border-radius: 5px;
    transition: width .33s ease;
    width: 100%;
}
















.paralax-cover-image {
    background-image: url('../assets/img/assurance/habitation.jpg');
    position: relative;
    background-size: contain !important;
    background-position: 50%;
    min-height: 210px;
    width: 100%;
    margin: 0 0 0;
    display: flex;
    /*padding: 20px;*/
    align-items: center;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;

}

.paralax-cover-image p {
    color: rgb(255, 255, 255);
    font-size: 20px;
    font-weight: 300;
}

.paralax-cover-image .paralax-cover-image-text,
.paralax-cover-image h2 {
    color: #fff;
    font-size: 2em;
    line-height: 1.25;
    z-index: 1;
    margin-bottom: 0;
    max-width: 610px;
    text-align: center;
    margin-left: 8.5%;
}

.paralax-cover-image.has-background-dim:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
}

.paralax-cover-image {
    background-attachment: fixed;
    background-position: 50% 50px;
}



.paralax-cover-image_mobile {
    background-image: url('../assets/img/assurance/habitation_mobile.jpg');
    position: relative;
    background-size: contain;
    background-position: 50%;
    min-height: 150px;
    width: 100%;
    margin: 0 0 0;
    display: flex;
    //padding: 20px;
    align-items: center;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;

}

.paralax-cover-image_mobile p {
    color: rgb(255, 255, 255);
    font-size: 20px;
    font-weight: 300;
    padding-bottom: 20Px;
}

.paralax-cover-image_mobile .paralax-cover-image-text_mobile,
.paralax-cover-image_mobile h2 {
    color: #fff;
    font-size: 2em;
    line-height: 1.25;
    z-index: 1;
    margin-bottom: 0;
    max-width: 610px;
    text-align: center;
    margin-left: 8.5%;
}

.paralax-cover-image_mobile.has-background-dim_mobile:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
}

.paralax-cover-image_mobile {
    // background-attachment: fixed;
    background-position: 100% 40px;
}


.hero {
    position: relative;
    background-size: cover;
    background-position: center center;
    height: 680px;
    min-height: 320px;
    max-height: 100%;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    align-items: center;
    -webkit-justify-content: center;
    -moz-justify-content: center;
    -ms-justify-content: center;
    justify-content: center;
    -ms-flex-pack: center;
    padding: 20px;
}

.hero .content_home {
    position: relative;
    min-height: 280px;
    width: 100%;
    margin-left: 8.5%;
    z-index: 2;
    /*//background: red;*/
}

.hero .content_home p {
    color: rgb(255, 255, 255);
    font-size: 20px;
    font-weight: 300;
    width: 100%;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
}












/*== start of code for tooltips ==*/
.tool {
    cursor: help;
    position: relative;
}


/*== common styles for both parts of tool tip ==*/
.tool::before,
.tool::after {
    left: 50%;
    opacity: 0;
    position: absolute;
    z-index: -100;
}

.tool:hover::before,
.tool:focus::before,
.tool:hover::after,
.tool:focus::after {
    opacity: 1;
    transform: scale(1) translateY(0);
    z-index: 100;
}


/*== pointer tip ==*/
.tool::before {
    border-style: solid;
    border-width: 1em 0.75em 0 0.75em;
    border-color: #565C61 transparent transparent transparent;
    bottom: 105%;
    content: "";
    margin-left: -0.5em;
    transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26), opacity .65s .5s;
    transform: scale(.6) translateY(-90%);
}

.tool:hover::before,
.tool:focus::before {
    transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26) .2s;
}


/*== speech bubble ==*/
.tool::after {
    background: #565C61;
    border-radius: .25em;
    bottom: 120%;
    color: #EDEFF0;
    font-size: 15px;
    content: attr(data-tip);
    margin-left: -8.75em;
    padding: 1em;
    transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26) .2s;
    transform: scale(.6) translateY(50%);
    width: 17.5em;

}

.tool:hover::after,
.tool:focus::after {
    transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26);
}

@media (max-width: 760px) {
    .tool::after {
        font-size: .75em;
        margin-left: -5em;
        width: 10em;
    }
}

// css du loader
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}


.insurers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}

@media (max-width: 768px) {
  .insurers-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
}

.insurer-card {
  position: relative;
  border-radius: 12px;
  background: #ffffff;
  border: 2px solid #e2e8f0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.insurer-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border-color: #cbd5e0;
}

.insurer-card.selected {
  border-color: #ffa409;
  background: linear-gradient(135deg, #fff7ed 0%, #ffffff 100%);
  // box-shadow: 0 4px 20px rgba(255, 164, 9, 0.2);
}

.insurer-card.all-insurers {
  background: linear-gradient(135deg, #ffa409 0%, #ff8c00 100%);
  border-color: #ffa409;
  color: white;
}

.insurer-card.all-insurers.selected {
  background: linear-gradient(135deg, #e69500 0%, #cc7a00 100%);
  transform: scale(1.02);
}

.insurer-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.insurer-label {
  display: flex;
  align-items: center;
  padding: 1.25rem;
  cursor: pointer;
  width: 100%;
  height: 100%;
  position: relative;
  transition: all 0.3s ease;
}

.insurer-icon {
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7fafc;
  border-radius: 12px;
  margin-right: 1rem;
  transition: all 0.3s ease;
}

.insurer-card.selected .insurer-icon {
  background: rgba(255, 164, 9, 0.1);
}

.insurer-card.all-insurers .insurer-icon {
  background: rgba(255, 255, 255, 0.2);
}

.insurer-logo {
  max-width: 45px;
  max-height: 45px;
  object-fit: contain;
  filter: brightness(1);
  transition: all 0.3s ease;
}

.insurer-card.all-insurers .insurer-logo {
  filter: brightness(0) invert(1);
}

.insurer-info {
  flex: 1;
  min-width: 0;
}

.insurer-name {
  //font-size: 1rem;
  font-weight: 500;
  color: #2d3748;
  margin: 0 0 0.25rem 0;
  line-height: 1.2;
  word-break: break-word;
}

.insurer-card.all-insurers .insurer-name {
  color: white;
}

.insurer-badge {
  display: inline-block;
  font-size: 0.90rem;
  font-weight: 500;
  color: #718096;
  background: #edf2f7;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.insurer-card.all-insurers .insurer-badge {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.insurer-card.selected .insurer-badge {
  background: rgba(255, 164, 9, 0.2);
  color: #b45309;
}

.selection-indicator {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  opacity: 0;
  transform: scale(0.8);
}

.insurer-card.selected .selection-indicator {
  opacity: 1;
  transform: scale(1);
  background: #ffa409;
  color: white;
}

.selection-indicator i {
  font-size: 0.75rem;
}

.selection-summary {
  background: linear-gradient(135deg, #e6fffa 0%, #f0fff4 100%);
  border: 1px solid #9ae6b4;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
}

.summary-content {
  display: flex;
  align-items: center;
  color: #2f855a;
  font-weight: 500;
}

.summary-content i {
  margin-right: 0.5rem;
  font-size: 1.1rem;
}

/* Animation d'entrée */
.insurer-card {
  animation: slideInUp 0.6s ease-out;
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Animation pour les cartes sélectionnées */
.insurer-card.selected {
  animation: pulse 0.6s ease-out;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.02);
  }
  100% {
    transform: scale(1);
  }
}

/* Responsive amélioré */
@media (max-width: 480px) {
  .insurer-label {
    padding: 1rem;
  }
  
  .insurer-icon {
    width: 50px;
    height: 50px;
    margin-right: 0.75rem;
  }
  
  .insurer-logo {
    max-width: 35px;
    max-height: 35px;
  }
  
  .insurer-name {
    font-size: 1.5rem;
  }
  
  .modern-title {
    font-size: 1.1rem;
  }
}

/* Amélioration de l'accessibilité */
.insurer-card:focus-within {
  //outline: 2px solid #ffa409;
  outline-offset: 2px;
}

.insurer-input:focus + .insurer-label {
  box-shadow: 0 0 0 3px rgba(255, 164, 9, 0.3);
}

/* États de chargement */
.insurers-grid.loading .insurer-card {
  opacity: 0.6;
  pointer-events: none;
}
</style>
